var items = {
  "block.minecraft.acacia_button": "כפתור משיטה",
  "block.minecraft.acacia_door": "דלת שיטה",
  "block.minecraft.acacia_fence": "גדר שיטה",
  "block.minecraft.acacia_fence_gate": "שער גדר שיטה",
  "block.minecraft.acacia_hanging_sign": "שלט תלוי משיטה",
  "block.minecraft.acacia_leaves": "עלי שיטה",
  "block.minecraft.acacia_log": "עץ שיטה",
  "block.minecraft.acacia_planks": "קרשי עץ שיטה",
  "block.minecraft.acacia_pressure_plate": "לוחית לחץ משיטה",
  "block.minecraft.acacia_sapling": "שתיל שיטה",
  "block.minecraft.acacia_shelf": "מדף שיטה",
  "block.minecraft.acacia_sign": "שלט שיטה",
  "block.minecraft.acacia_slab": "קרש שיטה חצוי",
  "block.minecraft.acacia_stairs": "מדרגות שיטה",
  "block.minecraft.acacia_trapdoor": "דלת סתרים משיטה",
  "block.minecraft.acacia_wall_hanging_sign": "שלט קיר תלוי משיטה",
  "block.minecraft.acacia_wall_sign": "שלט קיר משיטה",
  "block.minecraft.acacia_wood": "עץ שיטה",
  "block.minecraft.activator_rail": "מסילת הפעלה",
  "block.minecraft.air": "אוויר",
  "block.minecraft.allium": "שום",
  "block.minecraft.amethyst_block": "בלוק אחלמה",
  "block.minecraft.amethyst_cluster": "גביש אחלמה",
  "block.minecraft.ancient_debris": "רסיסים עתיקים",
  "block.minecraft.andesite": "אנדזיט",
  "block.minecraft.andesite_slab": "אנדזיט חצוי",
  "block.minecraft.andesite_stairs": "מדרגות אנדזיט",
  "block.minecraft.andesite_wall": "קיר אנדזיט",
  "block.minecraft.anvil": "סדן",
  "block.minecraft.attached_melon_stem": "גזע אבטיח מחובר",
  "block.minecraft.attached_pumpkin_stem": "גזע דלעת מצורף",
  "block.minecraft.azalea": "אזליאה",
  "block.minecraft.azalea_leaves": "עלי אזליאה",
  "block.minecraft.azure_bluet": "פרח בר כחול",
  "block.minecraft.bamboo": "במבוק",
  "block.minecraft.bamboo_block": "בלוק במבוק",
  "block.minecraft.bamboo_button": "כפתור מבמבוק",
  "block.minecraft.bamboo_door": "דלת במבוק",
  "block.minecraft.bamboo_fence": "גדר במבוק",
  "block.minecraft.bamboo_fence_gate": "שער גדר במבוק",
  "block.minecraft.bamboo_hanging_sign": "שלט תלוי מבמבוק",
  "block.minecraft.bamboo_mosaic": "פסיפס במבוק",
  "block.minecraft.bamboo_mosaic_slab": "פסיפס במבוק חצוי",
  "block.minecraft.bamboo_mosaic_stairs": "מדרגות פסיפס במבוק",
  "block.minecraft.bamboo_planks": "קרשי עץ במבוק",
  "block.minecraft.bamboo_pressure_plate": "לוחית לחץ מבמבוק",
  "block.minecraft.bamboo_sapling": "ניצן במבוק",
  "block.minecraft.bamboo_shelf": "מדף במבוק",
  "block.minecraft.bamboo_sign": "שלט במבוק",
  "block.minecraft.bamboo_slab": "קרש במבוק חצוי",
  "block.minecraft.bamboo_stairs": "מדרגות במבוק",
  "block.minecraft.bamboo_trapdoor": "דלת סתרים מבמבוק",
  "block.minecraft.bamboo_wall_hanging_sign": "שלט קיר תלוי מבמבוק",
  "block.minecraft.bamboo_wall_sign": "שלט קיר מבמבוק",
  "block.minecraft.banner.base.black": "שדה שחור מלא",
  "block.minecraft.banner.base.blue": "שדה כחול מלא",
  "block.minecraft.banner.base.brown": "שדה חום מלא",
  "block.minecraft.banner.base.cyan": "שדה בצבע ציאן מלא",
  "block.minecraft.banner.base.gray": "שדה אפור מלא",
  "block.minecraft.banner.base.green": "שדה ירוק מלא",
  "block.minecraft.banner.base.light_blue": "שדה תכלת מלא",
  "block.minecraft.banner.base.light_gray": "שדה אפור בהיר מלא",
  "block.minecraft.banner.base.lime": "שדה בצבע ליים מלא",
  "block.minecraft.banner.base.magenta": "שדה בצבע מג׳נטה מלא",
  "block.minecraft.banner.base.orange": "שדה כתום מלא",
  "block.minecraft.banner.base.pink": "שדה ורוד מלא",
  "block.minecraft.banner.base.purple": "שדה סגול מלא",
  "block.minecraft.banner.base.red": "שדה אדום מלא",
  "block.minecraft.banner.base.white": "שדה לבן מלא",
  "block.minecraft.banner.base.yellow": "שדה צהוב מלא",
  "block.minecraft.banner.border.black": "בורדור שחור",
  "block.minecraft.banner.border.blue": "בורדור כחול",
  "block.minecraft.banner.border.brown": "בורדור חום",
  "block.minecraft.banner.border.cyan": "בורדור ציאן",
  "block.minecraft.banner.border.gray": "בורדור אפור",
  "block.minecraft.banner.border.green": "בורדור ירוק",
  "block.minecraft.banner.border.light_blue": "בורדור תכלת",
  "block.minecraft.banner.border.light_gray": "בורדור אפור בהיר",
  "block.minecraft.banner.border.lime": "בורדור ליים",
  "block.minecraft.banner.border.magenta": "בורדור מג'נטה",
  "block.minecraft.banner.border.orange": "בורדור כתום",
  "block.minecraft.banner.border.pink": "בורדור ורוד",
  "block.minecraft.banner.border.purple": "בורדור סגול",
  "block.minecraft.banner.border.red": "בורדור אדום",
  "block.minecraft.banner.border.white": "בורדור לבן",
  "block.minecraft.banner.border.yellow": "בורדור צהוב",
  "block.minecraft.banner.bricks.black": "שדה לבנים שחורות",
  "block.minecraft.banner.bricks.blue": "שדה לבנים כחולות",
  "block.minecraft.banner.bricks.brown": "שדה לבנים חומות",
  "block.minecraft.banner.bricks.cyan": "שדה לבנים בצבע ציאן",
  "block.minecraft.banner.bricks.gray": "שדה לבנים אפורות",
  "block.minecraft.banner.bricks.green": "שדה לבנים ירוקות",
  "block.minecraft.banner.bricks.light_blue": "שדה לבנים בצבע תכלת",
  "block.minecraft.banner.bricks.light_gray": "שדה לבנים בצבע אפור בהיר",
  "block.minecraft.banner.bricks.lime": "שדה לבנים בצבע ליים",
  "block.minecraft.banner.bricks.magenta": "שדה לבנים בצבע מג'נטה",
  "block.minecraft.banner.bricks.orange": "שדה לבנים כתומות",
  "block.minecraft.banner.bricks.pink": "שדה לבנים ורודות",
  "block.minecraft.banner.bricks.purple": "שדה לבנים סגולות",
  "block.minecraft.banner.bricks.red": "שדה לבנים אדומות",
  "block.minecraft.banner.bricks.white": "שדה לבנים לבנות",
  "block.minecraft.banner.bricks.yellow": "שדה לבנים צהובות",
  "block.minecraft.banner.circle.black": "ראונדל שחור",
  "block.minecraft.banner.circle.blue": "ראונדל כחול",
  "block.minecraft.banner.circle.brown": "ראונדל חום",
  "block.minecraft.banner.circle.cyan": "ראונדל ציאן",
  "block.minecraft.banner.circle.gray": "ראונדל אפור",
  "block.minecraft.banner.circle.green": "ראונדל ירוק",
  "block.minecraft.banner.circle.light_blue": "ראונדל תכלת",
  "block.minecraft.banner.circle.light_gray": "ראונדל אפור בהיר",
  "block.minecraft.banner.circle.lime": "ראונדל ליים",
  "block.minecraft.banner.circle.magenta": "ראונדל מג'נטה",
  "block.minecraft.banner.circle.orange": "ראונדל כתום",
  "block.minecraft.banner.circle.pink": "ראונדל ורוד",
  "block.minecraft.banner.circle.purple": "ראונדל סגול",
  "block.minecraft.banner.circle.red": "ראונדל אדום",
  "block.minecraft.banner.circle.white": "ראונדל לבן",
  "block.minecraft.banner.circle.yellow": "ראונדל צהוב",
  "block.minecraft.banner.creeper.black": "מטען קריפר שחור",
  "block.minecraft.banner.creeper.blue": "מטען קריפר כחול",
  "block.minecraft.banner.creeper.brown": "מטען קריפר חום",
  "block.minecraft.banner.creeper.cyan": "מטען קריפר ציאן",
  "block.minecraft.banner.creeper.gray": "מטען קריפר אפור",
  "block.minecraft.banner.creeper.green": "מטען קריפר ירוק",
  "block.minecraft.banner.creeper.light_blue": "מטען קריפר תכלת",
  "block.minecraft.banner.creeper.light_gray": "מטען קריפר אפור בהיר",
  "block.minecraft.banner.creeper.lime": "מטען קריפר ליים",
  "block.minecraft.banner.creeper.magenta": "מטען קריפר מג'נטה",
  "block.minecraft.banner.creeper.orange": "מטען קריפר כתום",
  "block.minecraft.banner.creeper.pink": "מטען קריפר ורוד",
  "block.minecraft.banner.creeper.purple": "מטען קריפר סגול",
  "block.minecraft.banner.creeper.red": "מטען קריפר אדום",
  "block.minecraft.banner.creeper.white": "מטען קריפר לבן",
  "block.minecraft.banner.creeper.yellow": "מטען קריפר צהוב",
  "block.minecraft.banner.cross.black": "צלב אלכסוני שחור",
  "block.minecraft.banner.cross.blue": "צלב אלכסוני כחול",
  "block.minecraft.banner.cross.brown": "צלב אלכסוני חום",
  "block.minecraft.banner.cross.cyan": "צלב אלכסוני ציאן",
  "block.minecraft.banner.cross.gray": "צלב אלכסוני אפור",
  "block.minecraft.banner.cross.green": "צלב אלכסוני ירוק",
  "block.minecraft.banner.cross.light_blue": "צלב אלכסוני תכלת",
  "block.minecraft.banner.cross.light_gray": "צלב אלכסוני אפור בהיר",
  "block.minecraft.banner.cross.lime": "צלב אלכסוני ליים",
  "block.minecraft.banner.cross.magenta": "צלב אלכסוני מג'נטה",
  "block.minecraft.banner.cross.orange": "צלב אלכסוני כתום",
  "block.minecraft.banner.cross.pink": "צלב אלכסוני ורוד",
  "block.minecraft.banner.cross.purple": "צלב אלכסוני סגול",
  "block.minecraft.banner.cross.red": "צלב אלכסוני אדום",
  "block.minecraft.banner.cross.white": "צלב אלכסוני לבן",
  "block.minecraft.banner.cross.yellow": "צלב אלכסוני צהוב",
  "block.minecraft.banner.curly_border.black": "בורדור שחור משונן",
  "block.minecraft.banner.curly_border.blue": "בורדור כחול משונן",
  "block.minecraft.banner.curly_border.brown": "בורדור חום משונן",
  "block.minecraft.banner.curly_border.cyan": "בורדור ציאן משונן",
  "block.minecraft.banner.curly_border.gray": "בורדור אפור משונן",
  "block.minecraft.banner.curly_border.green": "בורדור ירוק משונן",
  "block.minecraft.banner.curly_border.light_blue": "בורדור תכלת משונן",
  "block.minecraft.banner.curly_border.light_gray": "בורדור אפור בהיר משונן",
  "block.minecraft.banner.curly_border.lime": "בורדור ליים משונן",
  "block.minecraft.banner.curly_border.magenta": "בורדור מג'נטה משונן",
  "block.minecraft.banner.curly_border.orange": "בורדור כתום משונן",
  "block.minecraft.banner.curly_border.pink": "בורדור ורוד משונן",
  "block.minecraft.banner.curly_border.purple": "בורדור סגול משונן",
  "block.minecraft.banner.curly_border.red": "בורדור אדום משונן",
  "block.minecraft.banner.curly_border.white": "בורדור לבן משונן",
  "block.minecraft.banner.curly_border.yellow": "בורדור צהוב משונן",
  "block.minecraft.banner.diagonal_left.black": "מחולק בבנד סיניסטר שחור",
  "block.minecraft.banner.diagonal_left.blue": "מחולק בבנד סיניסטר כחול",
  "block.minecraft.banner.diagonal_left.brown": "מחולק בבנד סיניסטר חום",
  "block.minecraft.banner.diagonal_left.cyan": "מחולק בבנד סיניסטר ציאן",
  "block.minecraft.banner.diagonal_left.gray": "מחולק בבנד סיניסטר אפור",
  "block.minecraft.banner.diagonal_left.green": "מחולק בבנד סיניסטר ירוק",
  "block.minecraft.banner.diagonal_left.light_blue": "מחולק בבנד סיניסטר תכלת",
  "block.minecraft.banner.diagonal_left.light_gray": "מחולק בבנד סיניסטר אפור בהיר",
  "block.minecraft.banner.diagonal_left.lime": "מחולק בבנד סיניסטר ליים",
  "block.minecraft.banner.diagonal_left.magenta": "מחולק בבנד סיניסטר מג'נטה",
  "block.minecraft.banner.diagonal_left.orange": "מחולק בבנד סיניסטר כתום",
  "block.minecraft.banner.diagonal_left.pink": "מחולק בבנד סיניסטר ורוד",
  "block.minecraft.banner.diagonal_left.purple": "מחולק בבנד סיניסטר סגול",
  "block.minecraft.banner.diagonal_left.red": "מחולק בבנד סיניסטר אדום",
  "block.minecraft.banner.diagonal_left.white": "מחולק בבנד סיניסטר לבן",
  "block.minecraft.banner.diagonal_left.yellow": "מחולק בבנד סיניסטר צהוב",
  "block.minecraft.banner.diagonal_right.black": "מחולק בבנד שחור",
  "block.minecraft.banner.diagonal_right.blue": "מחולק בבנד כחול",
  "block.minecraft.banner.diagonal_right.brown": "מחולק בבנד חום",
  "block.minecraft.banner.diagonal_right.cyan": "מחולק בבנד ציאן",
  "block.minecraft.banner.diagonal_right.gray": "מחולק בבנד אפור",
  "block.minecraft.banner.diagonal_right.green": "מחולק בבנד ירוק",
  "block.minecraft.banner.diagonal_right.light_blue": "מחולק בבנד תכלת",
  "block.minecraft.banner.diagonal_right.light_gray": "מחולק בבנד אפור בהיר",
  "block.minecraft.banner.diagonal_right.lime": "מחולק בבנד ליים",
  "block.minecraft.banner.diagonal_right.magenta": "מחולק בבנד מג'נטה",
  "block.minecraft.banner.diagonal_right.orange": "מחולק בבנד כתום",
  "block.minecraft.banner.diagonal_right.pink": "מחולק בבנד ורוד",
  "block.minecraft.banner.diagonal_right.purple": "מחולק בבנד סגול",
  "block.minecraft.banner.diagonal_right.red": "מחולק בבנד אדום",
  "block.minecraft.banner.diagonal_right.white": "מחולק בבנד לבן",
  "block.minecraft.banner.diagonal_right.yellow": "מחולק בבנד צהוב",
  "block.minecraft.banner.diagonal_up_left.black": "מחולק בבנד שחור הפוך",
  "block.minecraft.banner.diagonal_up_left.blue": "מחולק בבנד כחול הפוך",
  "block.minecraft.banner.diagonal_up_left.brown": "מחולק בבנד חום הפוך",
  "block.minecraft.banner.diagonal_up_left.cyan": "מחולק בבנד ציאן הפוך",
  "block.minecraft.banner.diagonal_up_left.gray": "מחולק בבנד אפור הפוך",
  "block.minecraft.banner.diagonal_up_left.green": "מחולק בבנד ירוק הפוך",
  "block.minecraft.banner.diagonal_up_left.light_blue": "מחולק בבנד תכלת הפוך",
  "block.minecraft.banner.diagonal_up_left.light_gray": "מחולק בבנד אפור בהיר הפוך",
  "block.minecraft.banner.diagonal_up_left.lime": "מחולק בבנד ליים הפוך",
  "block.minecraft.banner.diagonal_up_left.magenta": "מחולק בבנד מג'נטה הפוך",
  "block.minecraft.banner.diagonal_up_left.orange": "מחולק בבנד כתום הפוך",
  "block.minecraft.banner.diagonal_up_left.pink": "מחולק בבנד ורוד הפוך",
  "block.minecraft.banner.diagonal_up_left.purple": "מחולק בבנד סגול הפוך",
  "block.minecraft.banner.diagonal_up_left.red": "מחולק בבנד אדום הפוך",
  "block.minecraft.banner.diagonal_up_left.white": "מחולק בבנד לבן הפוך",
  "block.minecraft.banner.diagonal_up_left.yellow": "מחולק בבנד צהוב הפוך",
  "block.minecraft.banner.diagonal_up_right.black": "מחולק בבנד סיניסטר שחור הפוך",
  "block.minecraft.banner.diagonal_up_right.blue": "מחולק בבנד סיניסטר כחול הפוך",
  "block.minecraft.banner.diagonal_up_right.brown": "מחולק בבנד סיניסטר חום הפוך",
  "block.minecraft.banner.diagonal_up_right.cyan": "מחולק בבנד סיניסטר ציאן הפוך",
  "block.minecraft.banner.diagonal_up_right.gray": "מחולק בבנד סיניסטר אפור הפוך",
  "block.minecraft.banner.diagonal_up_right.green": "מחולק בבנד סיניסטר ירוק הפוך",
  "block.minecraft.banner.diagonal_up_right.light_blue": "מחולק בבנד סיניסטר תכלת הפוך",
  "block.minecraft.banner.diagonal_up_right.light_gray": "מחולק בבנד סיניסטר אפור בהיר הפוך",
  "block.minecraft.banner.diagonal_up_right.lime": "מחולק בבנד סיניסטר ליים הפוך",
  "block.minecraft.banner.diagonal_up_right.magenta": "מחולק בבנד סיניסטר מג'נטה הפוך",
  "block.minecraft.banner.diagonal_up_right.orange": "מחולק בבנד סיניסטר כתום הפוך",
  "block.minecraft.banner.diagonal_up_right.pink": "מחולק בבנד סיניסטר ורוד הפוך",
  "block.minecraft.banner.diagonal_up_right.purple": "מחולק בבנד סיניסטר סגול הפוך",
  "block.minecraft.banner.diagonal_up_right.red": "מחולק בבנד סיניסטר אדום הפוך",
  "block.minecraft.banner.diagonal_up_right.white": "מחולק בבנד סיניסטר לבן הפוך",
  "block.minecraft.banner.diagonal_up_right.yellow": "מחולק בבנד סיניסטר צהוב הפוך",
  "block.minecraft.banner.flow.black": "זרימה שחורה",
  "block.minecraft.banner.flow.blue": "זרימה כחולה",
  "block.minecraft.banner.flow.brown": "זרימה חומה",
  "block.minecraft.banner.flow.cyan": "זרימה ציאן",
  "block.minecraft.banner.flow.gray": "זרימה אפורה",
  "block.minecraft.banner.flow.green": "זרימה ירוקה",
  "block.minecraft.banner.flow.light_blue": "זרימה תכלת",
  "block.minecraft.banner.flow.light_gray": "זרימה אפורה בהירה",
  "block.minecraft.banner.flow.lime": "זרימה ליים",
  "block.minecraft.banner.flow.magenta": "זרימה מג'נטה",
  "block.minecraft.banner.flow.orange": "זרימה כתומה",
  "block.minecraft.banner.flow.pink": "זרימה ורודה",
  "block.minecraft.banner.flow.purple": "זרימה סגולה",
  "block.minecraft.banner.flow.red": "זרימה אדומה",
  "block.minecraft.banner.flow.white": "זרימה לבנה",
  "block.minecraft.banner.flow.yellow": "זרימה צהובה",
  "block.minecraft.banner.flower.black": "מטען פרח שחור",
  "block.minecraft.banner.flower.blue": "מטען פרח כחול",
  "block.minecraft.banner.flower.brown": "מטען פרח חום",
  "block.minecraft.banner.flower.cyan": "מטען פרח ציאן",
  "block.minecraft.banner.flower.gray": "מטען פרח אפור",
  "block.minecraft.banner.flower.green": "מטען פרח ירוק",
  "block.minecraft.banner.flower.light_blue": "מטען פרח תכלת",
  "block.minecraft.banner.flower.light_gray": "מטען פרח אפור בהיר",
  "block.minecraft.banner.flower.lime": "מטען פרח ליים",
  "block.minecraft.banner.flower.magenta": "מטען פרח מג'נטה",
  "block.minecraft.banner.flower.orange": "מטען פרח כתום",
  "block.minecraft.banner.flower.pink": "מטען פרח ורוד",
  "block.minecraft.banner.flower.purple": "מטען פרח סגול",
  "block.minecraft.banner.flower.red": "מטען פרח אדום",
  "block.minecraft.banner.flower.white": "מטען פרח לבן",
  "block.minecraft.banner.flower.yellow": "מטען פרח צהוב",
  "block.minecraft.banner.globe.black": "גלובוס שחור",
  "block.minecraft.banner.globe.blue": "גלובוס כחול",
  "block.minecraft.banner.globe.brown": "גלובוס חום",
  "block.minecraft.banner.globe.cyan": "גלובוס טורקיז",
  "block.minecraft.banner.globe.gray": "גלובוס אפור",
  "block.minecraft.banner.globe.green": "גלובוס ירוק",
  "block.minecraft.banner.globe.light_blue": "גלובוס תכלת",
  "block.minecraft.banner.globe.light_gray": "גלובוס אפור בהיר",
  "block.minecraft.banner.globe.lime": "גלובוס ליים",
  "block.minecraft.banner.globe.magenta": "גלובוס מג'נטה",
  "block.minecraft.banner.globe.orange": "גלובוס כתום",
  "block.minecraft.banner.globe.pink": "גלובוס ורוד",
  "block.minecraft.banner.globe.purple": "גלובוס סגול",
  "block.minecraft.banner.globe.red": "גלובוס אדום",
  "block.minecraft.banner.globe.white": "גלובוס לבן",
  "block.minecraft.banner.globe.yellow": "גלובוס צהוב",
  "block.minecraft.banner.gradient.black": "שחור הדרגתי",
  "block.minecraft.banner.gradient.blue": "כחול הדרגתי",
  "block.minecraft.banner.gradient.brown": "חום הדרגתי",
  "block.minecraft.banner.gradient.cyan": "ציאן הדרגתי",
  "block.minecraft.banner.gradient.gray": "אפור הדרגתי",
  "block.minecraft.banner.gradient.green": "ירוק הדרגתי",
  "block.minecraft.banner.gradient.light_blue": "תכלת הדרגתי",
  "block.minecraft.banner.gradient.light_gray": "אפור בהיר הדרגתי",
  "block.minecraft.banner.gradient.lime": "ליים הדרגתי",
  "block.minecraft.banner.gradient.magenta": "מג'נטה הדרגתי",
  "block.minecraft.banner.gradient.orange": "כתום הדרגתי",
  "block.minecraft.banner.gradient.pink": "ורוד הדרגתי",
  "block.minecraft.banner.gradient.purple": "סגול הדרגתי",
  "block.minecraft.banner.gradient.red": "אדום הדרגתי",
  "block.minecraft.banner.gradient.white": "לבן הדרגתי",
  "block.minecraft.banner.gradient.yellow": "צהוב הדרגתי",
  "block.minecraft.banner.gradient_up.black": "בסיס שחור הדרגתי",
  "block.minecraft.banner.gradient_up.blue": "בסיס כחול הדרגתי",
  "block.minecraft.banner.gradient_up.brown": "בסיס חום הדרגתי",
  "block.minecraft.banner.gradient_up.cyan": "בסיס ציאן הדרגתי",
  "block.minecraft.banner.gradient_up.gray": "בסיס אפור הדרגתי",
  "block.minecraft.banner.gradient_up.green": "בסיס ירוק הדרגתי",
  "block.minecraft.banner.gradient_up.light_blue": "בסיס תכלת הדרגתי",
  "block.minecraft.banner.gradient_up.light_gray": "בסיס אפור בהיר הדרגתי",
  "block.minecraft.banner.gradient_up.lime": "בסיס ליים הדרגתי",
  "block.minecraft.banner.gradient_up.magenta": "בסיס מג'נטה הדרגתי",
  "block.minecraft.banner.gradient_up.orange": "בסיס כתום הדרגתי",
  "block.minecraft.banner.gradient_up.pink": "בסיס ורוד הדרגתי",
  "block.minecraft.banner.gradient_up.purple": "בסיס סגול הדרגתי",
  "block.minecraft.banner.gradient_up.red": "בסיס אדום הדרגתי",
  "block.minecraft.banner.gradient_up.white": "בסיס לבן הדרגתי",
  "block.minecraft.banner.gradient_up.yellow": "בסיס צהוב הדרגתי",
  "block.minecraft.banner.guster.black": "סופה שחורה",
  "block.minecraft.banner.guster.blue": "סופה כחולה",
  "block.minecraft.banner.guster.brown": "סופה חומה",
  "block.minecraft.banner.guster.cyan": "סופה ציאן",
  "block.minecraft.banner.guster.gray": "סופה אפורה",
  "block.minecraft.banner.guster.green": "סופה ירוקה",
  "block.minecraft.banner.guster.light_blue": "סופה תכלת",
  "block.minecraft.banner.guster.light_gray": "סופה אפורה בהירה",
  "block.minecraft.banner.guster.lime": "סופה ליים",
  "block.minecraft.banner.guster.magenta": "סופה מג'נטה",
  "block.minecraft.banner.guster.orange": "סופה כתומה",
  "block.minecraft.banner.guster.pink": "סופה ורודה",
  "block.minecraft.banner.guster.purple": "סופה סגולה",
  "block.minecraft.banner.guster.red": "סופה אדומה",
  "block.minecraft.banner.guster.white": "סופה לבנה",
  "block.minecraft.banner.guster.yellow": "סופה צהובה",
  "block.minecraft.banner.half_horizontal.black": "מחולק בפס שחור",
  "block.minecraft.banner.half_horizontal.blue": "מחולק בפס כחול",
  "block.minecraft.banner.half_horizontal.brown": "מחולק בפס חום",
  "block.minecraft.banner.half_horizontal.cyan": "מחולק בפס ציאן",
  "block.minecraft.banner.half_horizontal.gray": "מחולק בפס אפור",
  "block.minecraft.banner.half_horizontal.green": "מחולק בפס ירוק",
  "block.minecraft.banner.half_horizontal.light_blue": "מחולק בפס תכלת",
  "block.minecraft.banner.half_horizontal.light_gray": "מחולק בפס אפור בהיר",
  "block.minecraft.banner.half_horizontal.lime": "מחולק בפס ליים",
  "block.minecraft.banner.half_horizontal.magenta": "מחולק בפס מג'נטה",
  "block.minecraft.banner.half_horizontal.orange": "מחולק בפס כתום",
  "block.minecraft.banner.half_horizontal.pink": "מחולק בפס ורוד",
  "block.minecraft.banner.half_horizontal.purple": "מחולק בפס סגול",
  "block.minecraft.banner.half_horizontal.red": "מחולק בפס אדום",
  "block.minecraft.banner.half_horizontal.white": "מחולק בפס לבן",
  "block.minecraft.banner.half_horizontal.yellow": "מחולק בפס צהוב",
  "block.minecraft.banner.half_horizontal_bottom.black": "מחולק בפס שחור הפוך",
  "block.minecraft.banner.half_horizontal_bottom.blue": "מחולק בפס כחול הפוך",
  "block.minecraft.banner.half_horizontal_bottom.brown": "מחולק בפס חום הפוך",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "מחולק בפס ציאן הפוך",
  "block.minecraft.banner.half_horizontal_bottom.gray": "מחולק בפס אפור הפוך",
  "block.minecraft.banner.half_horizontal_bottom.green": "מחולק בפס ירוק הפוך",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "מחולק בפס תכלת הפוך",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "מחולק בפס אפור בהיר הפוך",
  "block.minecraft.banner.half_horizontal_bottom.lime": "מחולק בפס ליים הפוך",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "מחולק בפס מג'נטה הפוך",
  "block.minecraft.banner.half_horizontal_bottom.orange": "מחולק בפס כתום הפוך",
  "block.minecraft.banner.half_horizontal_bottom.pink": "מחולק בפס ורוד הפוך",
  "block.minecraft.banner.half_horizontal_bottom.purple": "פס חוצה תחתון סגול",
  "block.minecraft.banner.half_horizontal_bottom.red": "מחולק בפס אדום הפוך",
  "block.minecraft.banner.half_horizontal_bottom.white": "מחולק בפס לבן הפוך",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "מחולק בפס צהוב הפוך",
  "block.minecraft.banner.half_vertical.black": "מחולק בפאלה שחור",
  "block.minecraft.banner.half_vertical.blue": "מחולק בפאלה כחול",
  "block.minecraft.banner.half_vertical.brown": "מחולק בפאלה חום",
  "block.minecraft.banner.half_vertical.cyan": "מחולק בפאלה ציאן",
  "block.minecraft.banner.half_vertical.gray": "מחולק בפאלה אפור",
  "block.minecraft.banner.half_vertical.green": "מחולק בפאלה ירוק",
  "block.minecraft.banner.half_vertical.light_blue": "מחולק בפאלה תכלת",
  "block.minecraft.banner.half_vertical.light_gray": "מחולק בפאלה אפור בהיר",
  "block.minecraft.banner.half_vertical.lime": "מחולק בפאלה ליים",
  "block.minecraft.banner.half_vertical.magenta": "מחולק בפאלה מג'נטה",
  "block.minecraft.banner.half_vertical.orange": "מחולק בפאלה כתום",
  "block.minecraft.banner.half_vertical.pink": "מחולק בפאלה ורוד",
  "block.minecraft.banner.half_vertical.purple": "מחולק בפאלה סגול",
  "block.minecraft.banner.half_vertical.red": "מחולק בפאלה אדום",
  "block.minecraft.banner.half_vertical.white": "מחולק בפאלה לבן",
  "block.minecraft.banner.half_vertical.yellow": "מחולק בפאלה צהוב",
  "block.minecraft.banner.half_vertical_right.black": "מחולק בפאלה שחור הפוך",
  "block.minecraft.banner.half_vertical_right.blue": "מחולק בפאלה כחול הפוך",
  "block.minecraft.banner.half_vertical_right.brown": "מחולק בפאלה חום הפוך",
  "block.minecraft.banner.half_vertical_right.cyan": "מחולק בפאלה ציאן הפוך",
  "block.minecraft.banner.half_vertical_right.gray": "מחולק בפאלה אפור הפוך",
  "block.minecraft.banner.half_vertical_right.green": "מחולק בפאלה ירוק הפוך",
  "block.minecraft.banner.half_vertical_right.light_blue": "מחולק בפאלה תכלת הפוך",
  "block.minecraft.banner.half_vertical_right.light_gray": "מחולק בפאלה אפור בהיר הפוך",
  "block.minecraft.banner.half_vertical_right.lime": "מחולק בפאלה ליים הפוך",
  "block.minecraft.banner.half_vertical_right.magenta": "מחולק בפאלה מג'נטה הפוך",
  "block.minecraft.banner.half_vertical_right.orange": "מחולק בפאלה כתום הפוך",
  "block.minecraft.banner.half_vertical_right.pink": "מחולק בפאלה ורוד הפוך",
  "block.minecraft.banner.half_vertical_right.purple": "מחולק בפאלה סגול הפוך",
  "block.minecraft.banner.half_vertical_right.red": "מחולק בפאלה אדום הפוך",
  "block.minecraft.banner.half_vertical_right.white": "מחולק בפאלה לבן הפוך",
  "block.minecraft.banner.half_vertical_right.yellow": "מחולק בפאלה צהוב הפוך",
  "block.minecraft.banner.mojang.black": "סמל שחור",
  "block.minecraft.banner.mojang.blue": "סמל כחול",
  "block.minecraft.banner.mojang.brown": "סמל חום",
  "block.minecraft.banner.mojang.cyan": "סמל ציאן",
  "block.minecraft.banner.mojang.gray": "סמל אפור",
  "block.minecraft.banner.mojang.green": "סמל ירוק",
  "block.minecraft.banner.mojang.light_blue": "סמל תכלת",
  "block.minecraft.banner.mojang.light_gray": "סמל אפור בהיר",
  "block.minecraft.banner.mojang.lime": "סמל ליים",
  "block.minecraft.banner.mojang.magenta": "סמל מג'נטה",
  "block.minecraft.banner.mojang.orange": "סמל כתום",
  "block.minecraft.banner.mojang.pink": "סמל ורוד",
  "block.minecraft.banner.mojang.purple": "סמל סגול",
  "block.minecraft.banner.mojang.red": "סמל אדום",
  "block.minecraft.banner.mojang.white": "סמל לבן",
  "block.minecraft.banner.mojang.yellow": "סמל צהוב",
  "block.minecraft.banner.piglin.black": "חוטם שחור",
  "block.minecraft.banner.piglin.blue": "חוטם כחול",
  "block.minecraft.banner.piglin.brown": "חוטם חום",
  "block.minecraft.banner.piglin.cyan": "חוטם ציאן",
  "block.minecraft.banner.piglin.gray": "חוטם אפור",
  "block.minecraft.banner.piglin.green": "חוטם ירוק",
  "block.minecraft.banner.piglin.light_blue": "חוטם תכלת",
  "block.minecraft.banner.piglin.light_gray": "חוטם אפור בהיר",
  "block.minecraft.banner.piglin.lime": "חוטם ליים",
  "block.minecraft.banner.piglin.magenta": "חוטם מג'נטה",
  "block.minecraft.banner.piglin.orange": "חוטם כתום",
  "block.minecraft.banner.piglin.pink": "חוטם ורוד",
  "block.minecraft.banner.piglin.purple": "חוטם סגול",
  "block.minecraft.banner.piglin.red": "חוטם אדום",
  "block.minecraft.banner.piglin.white": "חוטם לבן",
  "block.minecraft.banner.piglin.yellow": "חוטם צהוב",
  "block.minecraft.banner.rhombus.black": "מעוין שחור",
  "block.minecraft.banner.rhombus.blue": "מעוין כחול",
  "block.minecraft.banner.rhombus.brown": "מעוין חום",
  "block.minecraft.banner.rhombus.cyan": "מעוין ציאן",
  "block.minecraft.banner.rhombus.gray": "מעוין אפור",
  "block.minecraft.banner.rhombus.green": "מעוין ירוק",
  "block.minecraft.banner.rhombus.light_blue": "מעוין תכלת",
  "block.minecraft.banner.rhombus.light_gray": "מעוין אפור בהיר",
  "block.minecraft.banner.rhombus.lime": "מעויין ליים",
  "block.minecraft.banner.rhombus.magenta": "מעוין מג'נטה",
  "block.minecraft.banner.rhombus.orange": "מעוין כתום",
  "block.minecraft.banner.rhombus.pink": "מעוין ורוד",
  "block.minecraft.banner.rhombus.purple": "מעוין סגול",
  "block.minecraft.banner.rhombus.red": "מעוין אדום",
  "block.minecraft.banner.rhombus.white": "לוזנג' לבן",
  "block.minecraft.banner.rhombus.yellow": "מעוין צהוב",
  "block.minecraft.banner.skull.black": "מטען גולגולת שחורה",
  "block.minecraft.banner.skull.blue": "מטען גולגולת כחולה",
  "block.minecraft.banner.skull.brown": "מטען גולגולת חומה",
  "block.minecraft.banner.skull.cyan": "מטען גולגולת ציאן",
  "block.minecraft.banner.skull.gray": "מטען גולגולת אפורה",
  "block.minecraft.banner.skull.green": "מטען גולגולת ירוקה",
  "block.minecraft.banner.skull.light_blue": "גולגולת תכלת",
  "block.minecraft.banner.skull.light_gray": "מטען גולגולת אפורה בהירה",
  "block.minecraft.banner.skull.lime": "מטען גולגולת ליים",
  "block.minecraft.banner.skull.magenta": "גולגולת מג'נטה",
  "block.minecraft.banner.skull.orange": "מטען גולגולת כתומה",
  "block.minecraft.banner.skull.pink": "מטען גולגולת ורודה",
  "block.minecraft.banner.skull.purple": "מטען גולגולת סגולה",
  "block.minecraft.banner.skull.red": "מטען גולגולת אדומה",
  "block.minecraft.banner.skull.white": "מטען גולגולת לבנה",
  "block.minecraft.banner.skull.yellow": "מטען גולגולת צהובה",
  "block.minecraft.banner.small_stripes.black": "פאלי שחור",
  "block.minecraft.banner.small_stripes.blue": "פאלי כחול",
  "block.minecraft.banner.small_stripes.brown": "פאלי חום",
  "block.minecraft.banner.small_stripes.cyan": "פאלי ציאן",
  "block.minecraft.banner.small_stripes.gray": "פאלי אפור",
  "block.minecraft.banner.small_stripes.green": "פאלי ירוק",
  "block.minecraft.banner.small_stripes.light_blue": "פאלי תכלת",
  "block.minecraft.banner.small_stripes.light_gray": "פאלי אפור בהיר",
  "block.minecraft.banner.small_stripes.lime": "פאלי ליים",
  "block.minecraft.banner.small_stripes.magenta": "פאלי מג'נטה",
  "block.minecraft.banner.small_stripes.orange": "פאלי כתום",
  "block.minecraft.banner.small_stripes.pink": "פאלי ורוד",
  "block.minecraft.banner.small_stripes.purple": "פאלי סגול",
  "block.minecraft.banner.small_stripes.red": "פאלי אדום",
  "block.minecraft.banner.small_stripes.white": "פאלי לבן",
  "block.minecraft.banner.small_stripes.yellow": "פאלי צהוב",
  "block.minecraft.banner.square_bottom_left.black": "קנטון שחור בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.blue": "קנטון כחול בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.brown": "קנטון חום בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.cyan": "קנטון ציאן בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.gray": "קנטון אפור בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.green": "קנטון ירוק בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.light_blue": "קנטון תכלת בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.light_gray": "קנטון אפור בהיר בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.lime": "קנטון ליים בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.magenta": "קנטון מג'נטה בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.orange": "קנטון כתום בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.pink": "קנטון ורוד בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.purple": "קנטון סגול בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.red": "קנטון אדום בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.white": "קנטון לבן בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_left.yellow": "קנטון צהוב בדקסטר בסיס",
  "block.minecraft.banner.square_bottom_right.black": "קנטון שחור בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.blue": "קנטון כחול בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.brown": "קנטון חום בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.cyan": "קנטון ציאן בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.gray": "קנטון אפור בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.green": "קנטון ירוק בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.light_blue": "קנטון תכלת בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.light_gray": "קנטון אפור בהיר בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.lime": "קנטון ליים בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.magenta": "קנטון מג'נטה בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.orange": "קנטון כתום בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.pink": "קנטון ורוד בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.purple": "קנטון סגול בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.red": "קנטון אדום בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.white": "קנטון לבן בסיניסטר בסיס",
  "block.minecraft.banner.square_bottom_right.yellow": "קנטון צהוב בסיניסטר בסיס",
  "block.minecraft.banner.square_top_left.black": "קנטון שחור בדקסטר עליון",
  "block.minecraft.banner.square_top_left.blue": "קנטון כחול בדקסטר עליון",
  "block.minecraft.banner.square_top_left.brown": "קנטון חום בדקסטר עליון",
  "block.minecraft.banner.square_top_left.cyan": "קנטון ציאן בדקסטר עליון",
  "block.minecraft.banner.square_top_left.gray": "קנטון אפור בדקסטר עליון",
  "block.minecraft.banner.square_top_left.green": "קנטון ירוק בדקסטר עליון",
  "block.minecraft.banner.square_top_left.light_blue": "קנטון תכלת בדקסטר עליון",
  "block.minecraft.banner.square_top_left.light_gray": "קנטון אפור בהיר בדקסטר עליון",
  "block.minecraft.banner.square_top_left.lime": "קנטון ליים בדקסטר עליון",
  "block.minecraft.banner.square_top_left.magenta": "קנטון מג'נטה בדקסטר עליון",
  "block.minecraft.banner.square_top_left.orange": "קנטון כתום בדקסטר עליון",
  "block.minecraft.banner.square_top_left.pink": "קנטון ורוד בדקסטר עליון",
  "block.minecraft.banner.square_top_left.purple": "קנטון סגול בדקסטר עליון",
  "block.minecraft.banner.square_top_left.red": "קנטון אדום בדקסטר עליון",
  "block.minecraft.banner.square_top_left.white": "קנטון לבן בדקסטר עליון",
  "block.minecraft.banner.square_top_left.yellow": "קנטון צהוב בדקסטר עליון",
  "block.minecraft.banner.square_top_right.black": "קנטון שחור בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.blue": "קנטון כחול בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.brown": "קנטון חום בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.cyan": "קנטון ציאן בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.gray": "קנטון אפור בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.green": "קנטון ירוק בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.light_blue": "קנטון תכלת בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.light_gray": "קנטון אפור בהיר בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.lime": "קנטון ליים בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.magenta": "קנטון מג'נטה בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.orange": "קנטון כתום בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.pink": "קנטון ורוד בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.purple": "קנטון סגול בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.red": "קנטון אדום בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.white": "קנטון לבן בסיניסטר עליון",
  "block.minecraft.banner.square_top_right.yellow": "קנטון צהוב בסיניסטר עליון",
  "block.minecraft.banner.straight_cross.black": "צלב שחור",
  "block.minecraft.banner.straight_cross.blue": "צלב כחול",
  "block.minecraft.banner.straight_cross.brown": "צלב חום",
  "block.minecraft.banner.straight_cross.cyan": "צלב ציאן",
  "block.minecraft.banner.straight_cross.gray": "צלב אפור",
  "block.minecraft.banner.straight_cross.green": "צלב ירוק",
  "block.minecraft.banner.straight_cross.light_blue": "צלב תכלת",
  "block.minecraft.banner.straight_cross.light_gray": "צלב אפור בהיר",
  "block.minecraft.banner.straight_cross.lime": "צלב ליים",
  "block.minecraft.banner.straight_cross.magenta": "צלב מג'נטה",
  "block.minecraft.banner.straight_cross.orange": "צלב כתום",
  "block.minecraft.banner.straight_cross.pink": "צלב ורוד",
  "block.minecraft.banner.straight_cross.purple": "צלב סגול",
  "block.minecraft.banner.straight_cross.red": "צלב אדום",
  "block.minecraft.banner.straight_cross.white": "צלב לבן",
  "block.minecraft.banner.straight_cross.yellow": "צלב צהוב",
  "block.minecraft.banner.stripe_bottom.black": "בסיס שחור",
  "block.minecraft.banner.stripe_bottom.blue": "בסיס כחול",
  "block.minecraft.banner.stripe_bottom.brown": "בסיס חום",
  "block.minecraft.banner.stripe_bottom.cyan": "בסיס ציאן",
  "block.minecraft.banner.stripe_bottom.gray": "בסיס אפור",
  "block.minecraft.banner.stripe_bottom.green": "בסיס ירוק",
  "block.minecraft.banner.stripe_bottom.light_blue": "בסיס תכלת",
  "block.minecraft.banner.stripe_bottom.light_gray": "בסיס אפור בהיר",
  "block.minecraft.banner.stripe_bottom.lime": "בסיס ליים",
  "block.minecraft.banner.stripe_bottom.magenta": "בסיס מג'נטה",
  "block.minecraft.banner.stripe_bottom.orange": "בסיס כתום",
  "block.minecraft.banner.stripe_bottom.pink": "בסיס ורוד",
  "block.minecraft.banner.stripe_bottom.purple": "בסיס סגול",
  "block.minecraft.banner.stripe_bottom.red": "בסיס אדום",
  "block.minecraft.banner.stripe_bottom.white": "בסיס לבן",
  "block.minecraft.banner.stripe_bottom.yellow": "בסיס צהוב",
  "block.minecraft.banner.stripe_center.black": "פאלה שחור",
  "block.minecraft.banner.stripe_center.blue": "פאלה כחול",
  "block.minecraft.banner.stripe_center.brown": "פאלה חום",
  "block.minecraft.banner.stripe_center.cyan": "פאלה ציאן",
  "block.minecraft.banner.stripe_center.gray": "פאלה אפור",
  "block.minecraft.banner.stripe_center.green": "פאלה ירוק",
  "block.minecraft.banner.stripe_center.light_blue": "פאלה תכלת",
  "block.minecraft.banner.stripe_center.light_gray": "פאלה אפור בהיר",
  "block.minecraft.banner.stripe_center.lime": "פאלה ליים",
  "block.minecraft.banner.stripe_center.magenta": "פאלה מג'נטה",
  "block.minecraft.banner.stripe_center.orange": "פאלה כתום",
  "block.minecraft.banner.stripe_center.pink": "פאלה ורוד",
  "block.minecraft.banner.stripe_center.purple": "פאלה סגול",
  "block.minecraft.banner.stripe_center.red": "פאלה אדום",
  "block.minecraft.banner.stripe_center.white": "פאלה לבן",
  "block.minecraft.banner.stripe_center.yellow": "פאלה צהוב",
  "block.minecraft.banner.stripe_downleft.black": "בנד סיניסטר שחור",
  "block.minecraft.banner.stripe_downleft.blue": "בנד סיניסטר כחול",
  "block.minecraft.banner.stripe_downleft.brown": "בנד סיניסטר חום",
  "block.minecraft.banner.stripe_downleft.cyan": "בנד סיניסטר טורקיז",
  "block.minecraft.banner.stripe_downleft.gray": "בנד סיניסטר אפור",
  "block.minecraft.banner.stripe_downleft.green": "בנד סיניסטר ירוק",
  "block.minecraft.banner.stripe_downleft.light_blue": "בנד סיניסטר תכלת",
  "block.minecraft.banner.stripe_downleft.light_gray": "בנד סיניסטר אפור בהיר",
  "block.minecraft.banner.stripe_downleft.lime": "אלכסון ליים ימני",
  "block.minecraft.banner.stripe_downleft.magenta": "בנד סיניסטר מג'נטה",
  "block.minecraft.banner.stripe_downleft.orange": "בנד סיניסטר כתום",
  "block.minecraft.banner.stripe_downleft.pink": "בנד סיניסטר ורוד",
  "block.minecraft.banner.stripe_downleft.purple": "בנד סיניסטר סגול",
  "block.minecraft.banner.stripe_downleft.red": "בנד סיניסטר אדום",
  "block.minecraft.banner.stripe_downleft.white": "בנד סיניסטר לבן",
  "block.minecraft.banner.stripe_downleft.yellow": "בנד סיניסטר צהוב",
  "block.minecraft.banner.stripe_downright.black": "בנד שחור",
  "block.minecraft.banner.stripe_downright.blue": "בנד כחול",
  "block.minecraft.banner.stripe_downright.brown": "בנד חום",
  "block.minecraft.banner.stripe_downright.cyan": "בנד טורקיז",
  "block.minecraft.banner.stripe_downright.gray": "בנד אפור",
  "block.minecraft.banner.stripe_downright.green": "בנד ירוק",
  "block.minecraft.banner.stripe_downright.light_blue": "בנד תכלת",
  "block.minecraft.banner.stripe_downright.light_gray": "בנד אפור בהיר",
  "block.minecraft.banner.stripe_downright.lime": "אלכסון ליים",
  "block.minecraft.banner.stripe_downright.magenta": "בנד מג'נטה",
  "block.minecraft.banner.stripe_downright.orange": "בנד כתום",
  "block.minecraft.banner.stripe_downright.pink": "בנד ורוד",
  "block.minecraft.banner.stripe_downright.purple": "בנד סגול",
  "block.minecraft.banner.stripe_downright.red": "בנד אדום",
  "block.minecraft.banner.stripe_downright.white": "בנד לבן",
  "block.minecraft.banner.stripe_downright.yellow": "בנד צהוב",
  "block.minecraft.banner.stripe_left.black": "פאלה שחור בדקסטר",
  "block.minecraft.banner.stripe_left.blue": "פאלה כחול בדקסטר",
  "block.minecraft.banner.stripe_left.brown": "פאלה חום בדקסטר",
  "block.minecraft.banner.stripe_left.cyan": "פאלה ציאן בדקסטר",
  "block.minecraft.banner.stripe_left.gray": "פאלה אפור בדקסטר",
  "block.minecraft.banner.stripe_left.green": "פאלה ירוק בדקסטר",
  "block.minecraft.banner.stripe_left.light_blue": "פאלה תכלת בדקסטר",
  "block.minecraft.banner.stripe_left.light_gray": "פאלה אפור בהיר בדקסטר",
  "block.minecraft.banner.stripe_left.lime": "פאלה ליים בדקסטר",
  "block.minecraft.banner.stripe_left.magenta": "פאלה מג'נטה בדקסטר",
  "block.minecraft.banner.stripe_left.orange": "פאלה כתום בדקסטר",
  "block.minecraft.banner.stripe_left.pink": "פאלה ורוד בדקסטר",
  "block.minecraft.banner.stripe_left.purple": "פאלה סגול בדקסטר",
  "block.minecraft.banner.stripe_left.red": "פאלה אדום בדקסטר",
  "block.minecraft.banner.stripe_left.white": "פאלה לבן בדקסטר",
  "block.minecraft.banner.stripe_left.yellow": "פאלה צהוב בדקסטר",
  "block.minecraft.banner.stripe_middle.black": "פס שחור",
  "block.minecraft.banner.stripe_middle.blue": "פס כחול",
  "block.minecraft.banner.stripe_middle.brown": "פס חום",
  "block.minecraft.banner.stripe_middle.cyan": "פס ציאן",
  "block.minecraft.banner.stripe_middle.gray": "פס אפור",
  "block.minecraft.banner.stripe_middle.green": "פס ירוק",
  "block.minecraft.banner.stripe_middle.light_blue": "פס תכלת",
  "block.minecraft.banner.stripe_middle.light_gray": "פס אפור בהיר",
  "block.minecraft.banner.stripe_middle.lime": "פס ליים",
  "block.minecraft.banner.stripe_middle.magenta": "פס מג'נטה",
  "block.minecraft.banner.stripe_middle.orange": "פס כתום",
  "block.minecraft.banner.stripe_middle.pink": "פס ורוד",
  "block.minecraft.banner.stripe_middle.purple": "פס סגול",
  "block.minecraft.banner.stripe_middle.red": "פס אדום",
  "block.minecraft.banner.stripe_middle.white": "פס לבן",
  "block.minecraft.banner.stripe_middle.yellow": "פס צהוב",
  "block.minecraft.banner.stripe_right.black": "פאלה שחור בסיניסטר",
  "block.minecraft.banner.stripe_right.blue": "פאלה כחול בסיניסטר",
  "block.minecraft.banner.stripe_right.brown": "פאלה חום בסיניסטר",
  "block.minecraft.banner.stripe_right.cyan": "פאלה ציאן בסיניסטר",
  "block.minecraft.banner.stripe_right.gray": "פאלה אפור בסיניסטר",
  "block.minecraft.banner.stripe_right.green": "פאלה ירוק בסיניסטר",
  "block.minecraft.banner.stripe_right.light_blue": "פאלה תכלת בסיניסטר",
  "block.minecraft.banner.stripe_right.light_gray": "פאלה אפור בהיר בסיניסטר",
  "block.minecraft.banner.stripe_right.lime": "פאלה ליים בסיניסטר",
  "block.minecraft.banner.stripe_right.magenta": "פאלה מג'נטה בסיניסטר",
  "block.minecraft.banner.stripe_right.orange": "פאלה כתום בסיניסטר",
  "block.minecraft.banner.stripe_right.pink": "פאלה ורוד בסיניסטר",
  "block.minecraft.banner.stripe_right.purple": "פאלה סגול בסיניסטר",
  "block.minecraft.banner.stripe_right.red": "פאלה אדום בסיניסטר",
  "block.minecraft.banner.stripe_right.white": "פאלה לבן בסיניסטר",
  "block.minecraft.banner.stripe_right.yellow": "פאלה צהוב בסיניסטר",
  "block.minecraft.banner.stripe_top.black": "ראש שחור",
  "block.minecraft.banner.stripe_top.blue": "ראש כחול",
  "block.minecraft.banner.stripe_top.brown": "ראש חום",
  "block.minecraft.banner.stripe_top.cyan": "ראש ציאן",
  "block.minecraft.banner.stripe_top.gray": "ראש אפור",
  "block.minecraft.banner.stripe_top.green": "ראש ירוק",
  "block.minecraft.banner.stripe_top.light_blue": "ראש כחול בהיר",
  "block.minecraft.banner.stripe_top.light_gray": "ראש אפור בהיר",
  "block.minecraft.banner.stripe_top.lime": "ראש ליים",
  "block.minecraft.banner.stripe_top.magenta": "ראש מג'נטה",
  "block.minecraft.banner.stripe_top.orange": "ראש כתום",
  "block.minecraft.banner.stripe_top.pink": "ראש ורוד",
  "block.minecraft.banner.stripe_top.purple": "ראש סגול",
  "block.minecraft.banner.stripe_top.red": "ראש אדום",
  "block.minecraft.banner.stripe_top.white": "ראש לבן",
  "block.minecraft.banner.stripe_top.yellow": "ראש צהוב",
  "block.minecraft.banner.triangle_bottom.black": "שברון שחור",
  "block.minecraft.banner.triangle_bottom.blue": "שברון כחול",
  "block.minecraft.banner.triangle_bottom.brown": "שברון חום",
  "block.minecraft.banner.triangle_bottom.cyan": "שברון ציאן",
  "block.minecraft.banner.triangle_bottom.gray": "שברון אפור",
  "block.minecraft.banner.triangle_bottom.green": "שברון ירוק",
  "block.minecraft.banner.triangle_bottom.light_blue": "שברון תכלת",
  "block.minecraft.banner.triangle_bottom.light_gray": "שברון אפור בהיר",
  "block.minecraft.banner.triangle_bottom.lime": "שברון ליים",
  "block.minecraft.banner.triangle_bottom.magenta": "שברון מג'נטה",
  "block.minecraft.banner.triangle_bottom.orange": "שברון כתום",
  "block.minecraft.banner.triangle_bottom.pink": "שברון ורוד",
  "block.minecraft.banner.triangle_bottom.purple": "שברון סגול",
  "block.minecraft.banner.triangle_bottom.red": "שברון אדום",
  "block.minecraft.banner.triangle_bottom.white": "שברון לבן",
  "block.minecraft.banner.triangle_bottom.yellow": "שברון צהוב",
  "block.minecraft.banner.triangle_top.black": "שברון שחור הפוך",
  "block.minecraft.banner.triangle_top.blue": "שברון כחול הפוך",
  "block.minecraft.banner.triangle_top.brown": "שברון חום הפוך",
  "block.minecraft.banner.triangle_top.cyan": "שברון ציאן הפוך",
  "block.minecraft.banner.triangle_top.gray": "שברון אפור הפוך",
  "block.minecraft.banner.triangle_top.green": "שברון ירוק הפוך",
  "block.minecraft.banner.triangle_top.light_blue": "שברון תכלת הפוך",
  "block.minecraft.banner.triangle_top.light_gray": "שברון אפור בהיר הפוך",
  "block.minecraft.banner.triangle_top.lime": "משולש ליים למעלה",
  "block.minecraft.banner.triangle_top.magenta": "שברון מג'נטה הפוך",
  "block.minecraft.banner.triangle_top.orange": "שברון כתום הפוך",
  "block.minecraft.banner.triangle_top.pink": "שברון ורוד הפוך",
  "block.minecraft.banner.triangle_top.purple": "שברון סגול הפוך",
  "block.minecraft.banner.triangle_top.red": "שברון אדום הפוך",
  "block.minecraft.banner.triangle_top.white": "שברון לבן הפוך",
  "block.minecraft.banner.triangle_top.yellow": "שברון צהוב הפוך",
  "block.minecraft.banner.triangles_bottom.black": "בסיס שחור משונן",
  "block.minecraft.banner.triangles_bottom.blue": "בסיס כחול משונן",
  "block.minecraft.banner.triangles_bottom.brown": "בסיס חום משונן",
  "block.minecraft.banner.triangles_bottom.cyan": "בסיס ציאן משונן",
  "block.minecraft.banner.triangles_bottom.gray": "בסיס אפור משונן",
  "block.minecraft.banner.triangles_bottom.green": "בסיס ירוק משונן",
  "block.minecraft.banner.triangles_bottom.light_blue": "בסיס תכלת משונן",
  "block.minecraft.banner.triangles_bottom.light_gray": "בסיס אפור בהיר משונן",
  "block.minecraft.banner.triangles_bottom.lime": "בסיס ליים משונן",
  "block.minecraft.banner.triangles_bottom.magenta": "בסיס מג'נטה משונן",
  "block.minecraft.banner.triangles_bottom.orange": "בסיס כתום משונן",
  "block.minecraft.banner.triangles_bottom.pink": "בסיס ורוד משונן",
  "block.minecraft.banner.triangles_bottom.purple": "בסיס סגול משונן",
  "block.minecraft.banner.triangles_bottom.red": "בסיס אדום משונן",
  "block.minecraft.banner.triangles_bottom.white": "בסיס לבן משונן",
  "block.minecraft.banner.triangles_bottom.yellow": "בסיס צהוב משונן",
  "block.minecraft.banner.triangles_top.black": "ראש שחור משונן",
  "block.minecraft.banner.triangles_top.blue": "ראש כחול משונן",
  "block.minecraft.banner.triangles_top.brown": "ראש חום משונן",
  "block.minecraft.banner.triangles_top.cyan": "ראש ציאן משונן",
  "block.minecraft.banner.triangles_top.gray": "ראש אפור משונן",
  "block.minecraft.banner.triangles_top.green": "ראש ירוק משונן",
  "block.minecraft.banner.triangles_top.light_blue": "ראש תכלת משונן",
  "block.minecraft.banner.triangles_top.light_gray": "ראש אפור בהיר משונן",
  "block.minecraft.banner.triangles_top.lime": "ראש ליים משונן",
  "block.minecraft.banner.triangles_top.magenta": "ראש מג'נטה משונן",
  "block.minecraft.banner.triangles_top.orange": "ראש כתום משונן",
  "block.minecraft.banner.triangles_top.pink": "ראש ורוד משונן",
  "block.minecraft.banner.triangles_top.purple": "ראש סגול משונן",
  "block.minecraft.banner.triangles_top.red": "ראש אדום משונן",
  "block.minecraft.banner.triangles_top.white": "ראש לבן משונן",
  "block.minecraft.banner.triangles_top.yellow": "ראש צהוב משונן",
  "block.minecraft.barrel": "חבית",
  "block.minecraft.barrier": "מחסום",
  "block.minecraft.basalt": "בזלת",
  "block.minecraft.beacon": "משואה",
  "block.minecraft.beacon.primary": "כוח עיקרי",
  "block.minecraft.beacon.secondary": "כוח משני",
  "block.minecraft.bed.no_sleep": "אתה יכול לישון רק בלילה ובמהלך סופות ברקים",
  "block.minecraft.bed.not_safe": "לא ניתן לנוח כעת; ישנן מפלצות בקרבת מקום",
  "block.minecraft.bed.obstructed": "המיטה הזאת חסומה",
  "block.minecraft.bed.occupied": "מיטה זו תפוסה",
  "block.minecraft.bed.too_far_away": "לא ניתן לנוח כעת; המיטה רחוקה מדי",
  "block.minecraft.bedrock": "אבן יסוד",
  "block.minecraft.bee_nest": "קן דבורים",
  "block.minecraft.beehive": "כוורת",
  "block.minecraft.beetroots": "סלק אדום",
  "block.minecraft.bell": "פעמון",
  "block.minecraft.big_dripleaf": "עלה טפטוף גדול",
  "block.minecraft.big_dripleaf_stem": "גזע עלה טפטוף גדול",
  "block.minecraft.birch_button": "כפתור משדר",
  "block.minecraft.birch_door": "דלת שדר",
  "block.minecraft.birch_fence": "גדר שדר",
  "block.minecraft.birch_fence_gate": "שער גדר שדר",
  "block.minecraft.birch_hanging_sign": "שלט תלוי משדר",
  "block.minecraft.birch_leaves": "עלי שדר",
  "block.minecraft.birch_log": "עץ שדר",
  "block.minecraft.birch_planks": "קרשי עץ שדר",
  "block.minecraft.birch_pressure_plate": "לוחית לחץ משדר",
  "block.minecraft.birch_sapling": "שתיל שדר",
  "block.minecraft.birch_shelf": "מדף שדר",
  "block.minecraft.birch_sign": "שלט שדר",
  "block.minecraft.birch_slab": "קרש שדר חצוי",
  "block.minecraft.birch_stairs": "מדרגות שדר",
  "block.minecraft.birch_trapdoor": "דלת סתרים משדר",
  "block.minecraft.birch_wall_hanging_sign": "שלט קיר תלוי משדר",
  "block.minecraft.birch_wall_sign": "שלט קיר משדר",
  "block.minecraft.birch_wood": "עץ שדר",
  "block.minecraft.black_banner": "באנר שחור",
  "block.minecraft.black_bed": "מיטה שחורה",
  "block.minecraft.black_candle": "נר שחור",
  "block.minecraft.black_candle_cake": "עוגה עם נר שחור",
  "block.minecraft.black_carpet": "שטיח שחור",
  "block.minecraft.black_concrete": "בטון שחור",
  "block.minecraft.black_concrete_powder": "אבקת בטון שחורה",
  "block.minecraft.black_glazed_terracotta": "טרקוטה מזוגגת שחורה",
  "block.minecraft.black_shulker_box": "תיבת שולקר שחורה",
  "block.minecraft.black_stained_glass": "זכוכית שחורה",
  "block.minecraft.black_stained_glass_pane": "זגוגית שחורה",
  "block.minecraft.black_terracotta": "טרקוטה שחורה",
  "block.minecraft.black_wool": "צמר שחור",
  "block.minecraft.blackstone": "אבן שחורה",
  "block.minecraft.blackstone_slab": "אבן שחורה חצויה",
  "block.minecraft.blackstone_stairs": "מדרגות אבן שחורה",
  "block.minecraft.blackstone_wall": "קיר אבן שחורה",
  "block.minecraft.blast_furnace": "כבשן",
  "block.minecraft.blue_banner": "באנר כחול",
  "block.minecraft.blue_bed": "מיטה כחולה",
  "block.minecraft.blue_candle": "נר כחול",
  "block.minecraft.blue_candle_cake": "עוגה עם נר כחול",
  "block.minecraft.blue_carpet": "שטיח כחול",
  "block.minecraft.blue_concrete": "בטון כחול",
  "block.minecraft.blue_concrete_powder": "אבקת בטון כחולה",
  "block.minecraft.blue_glazed_terracotta": "טרקוטה מזוגגת כחולה",
  "block.minecraft.blue_ice": "קרח כחול",
  "block.minecraft.blue_orchid": "סחלב כחול",
  "block.minecraft.blue_shulker_box": "תיבת שולקר כחולה",
  "block.minecraft.blue_stained_glass": "זכוכית כחולה",
  "block.minecraft.blue_stained_glass_pane": "זגוגית כחולה",
  "block.minecraft.blue_terracotta": "טרקוטה כחולה",
  "block.minecraft.blue_wool": "צמר כחול",
  "block.minecraft.bone_block": "קוביית עצם",
  "block.minecraft.bookshelf": "מדף ספרים",
  "block.minecraft.brain_coral": "צמח אלמוג מוחי",
  "block.minecraft.brain_coral_block": "אלמוג מוחי",
  "block.minecraft.brain_coral_fan": "ענף אלמוג מוחי",
  "block.minecraft.brain_coral_wall_fan": "ענף קיר אלמוג מוחי",
  "block.minecraft.brewing_stand": "עמדת רקיחה",
  "block.minecraft.brick_slab": "לבנה חצויה",
  "block.minecraft.brick_stairs": "מדרגות לבנים",
  "block.minecraft.brick_wall": "קיר לבנים",
  "block.minecraft.bricks": "לבנים",
  "block.minecraft.brown_banner": "באנר חום",
  "block.minecraft.brown_bed": "מיטה חומה",
  "block.minecraft.brown_candle": "נר חום",
  "block.minecraft.brown_candle_cake": "עוגה עם נר חום",
  "block.minecraft.brown_carpet": "שטיח חום",
  "block.minecraft.brown_concrete": "בטון חום",
  "block.minecraft.brown_concrete_powder": "אבקת בטון חומה",
  "block.minecraft.brown_glazed_terracotta": "טרקוטה מזוגגת חומה",
  "block.minecraft.brown_mushroom": "פטריה חומה",
  "block.minecraft.brown_mushroom_block": "בלוק פטריות חומות",
  "block.minecraft.brown_shulker_box": "תיבת שולקר חומה",
  "block.minecraft.brown_stained_glass": "זכוכית חומה",
  "block.minecraft.brown_stained_glass_pane": "זגוגית חומה",
  "block.minecraft.brown_terracotta": "טרקוטה חומה",
  "block.minecraft.brown_wool": "צמר חום",
  "block.minecraft.bubble_column": "זרם בועות",
  "block.minecraft.bubble_coral": "צמח אלמוג בועות",
  "block.minecraft.bubble_coral_block": "אלמוג בועות",
  "block.minecraft.bubble_coral_fan": "ענף אלמוג בועות",
  "block.minecraft.bubble_coral_wall_fan": "ענף קיר אלמוג בועות",
  "block.minecraft.budding_amethyst": "מושבת אחלמה",
  "block.minecraft.bush": "שיח",
  "block.minecraft.cactus": "קקטוס",
  "block.minecraft.cactus_flower": "פרח קקטוס",
  "block.minecraft.cake": "עוגה",
  "block.minecraft.calcite": "קלציט",
  "block.minecraft.calibrated_sculk_sensor": "חיישן סקאלק מכויל",
  "block.minecraft.campfire": "מדורה",
  "block.minecraft.candle": "נר",
  "block.minecraft.candle_cake": "עוגת נר",
  "block.minecraft.carrots": "גזרים",
  "block.minecraft.cartography_table": "שולחן מיפוי",
  "block.minecraft.carved_pumpkin": "דלעת מגולפת",
  "block.minecraft.cauldron": "קדרה",
  "block.minecraft.cave_air": "אוויר מערות",
  "block.minecraft.cave_vines": "גפני מערות",
  "block.minecraft.cave_vines_plant": "צמח גפני מערות",
  "block.minecraft.chain": "שרשרת",
  "block.minecraft.chain_command_block": "קוביית פקודה משורשרת",
  "block.minecraft.cherry_button": "כפתור מעץ דובדבן",
  "block.minecraft.cherry_door": "דלת עץ דובדבן",
  "block.minecraft.cherry_fence": "גדר עץ דובדבן",
  "block.minecraft.cherry_fence_gate": "שער גדר עץ דובדבן",
  "block.minecraft.cherry_hanging_sign": "שלט תלוי מעץ דובדבן",
  "block.minecraft.cherry_leaves": "עלי עץ דובדבן",
  "block.minecraft.cherry_log": "עץ דובדבן",
  "block.minecraft.cherry_planks": "קרשי עץ דובדבן",
  "block.minecraft.cherry_pressure_plate": "לוחית לחץ מעץ דובדבן",
  "block.minecraft.cherry_sapling": "שתיל עץ דובדבן",
  "block.minecraft.cherry_shelf": "מדף עץ דובדבן",
  "block.minecraft.cherry_sign": "שלט עץ דובדבן",
  "block.minecraft.cherry_slab": "קרש עץ דובדבן חצוי",
  "block.minecraft.cherry_stairs": "מדרגות עץ דובדבן",
  "block.minecraft.cherry_trapdoor": "דלת סתרים מעץ דובדבן",
  "block.minecraft.cherry_wall_hanging_sign": "שלט תלוי מעץ דובדבן",
  "block.minecraft.cherry_wall_sign": "שלט קיר מעץ דובדבן",
  "block.minecraft.cherry_wood": "עץ דובדבן",
  "block.minecraft.chest": "תיבה",
  "block.minecraft.chipped_anvil": "סדן סדוק",
  "block.minecraft.chiseled_bookshelf": "מדף ספרים מפוסל",
  "block.minecraft.chiseled_copper": "נחושת מפוסלת",
  "block.minecraft.chiseled_deepslate": "לווחה מפוסלת",
  "block.minecraft.chiseled_nether_bricks": "לבני נד'ר מפוסלות",
  "block.minecraft.chiseled_polished_blackstone": "אבן שחורה מלוטשת מפוסלת",
  "block.minecraft.chiseled_quartz_block": "בלוק קוורץ מפוסל",
  "block.minecraft.chiseled_red_sandstone": "אבן חול אדומה מפוסלת",
  "block.minecraft.chiseled_resin_bricks": "לבני שרף מפוסלות",
  "block.minecraft.chiseled_sandstone": "אבן חול מפוסלת",
  "block.minecraft.chiseled_stone_bricks": "לבני אבן מפוסלות",
  "block.minecraft.chiseled_tuff": "טוף מפוסל",
  "block.minecraft.chiseled_tuff_bricks": "לבני טוף מפוסלות",
  "block.minecraft.chorus_flower": "פרח קורוס",
  "block.minecraft.chorus_plant": "צמח קורוס",
  "block.minecraft.clay": "חימר",
  "block.minecraft.closed_eyeblossom": "עינית לילה סגורה",
  "block.minecraft.coal_block": "בלוק פחם",
  "block.minecraft.coal_ore": "עפרת פחם",
  "block.minecraft.coarse_dirt": "עפר גס",
  "block.minecraft.cobbled_deepslate": "לווחה מרוצפת",
  "block.minecraft.cobbled_deepslate_slab": "לווחה מרוצפת חצויה",
  "block.minecraft.cobbled_deepslate_stairs": "מדרגות לווחה מרוצפת",
  "block.minecraft.cobbled_deepslate_wall": "קיר לווחה מרוצפת",
  "block.minecraft.cobblestone": "אבן מרוסקת",
  "block.minecraft.cobblestone_slab": "אבן מרוסקת חצויה",
  "block.minecraft.cobblestone_stairs": "מדרגות אבן מרוסקת",
  "block.minecraft.cobblestone_wall": "חומת אבן מרוסקת",
  "block.minecraft.cobweb": "קורי עכביש",
  "block.minecraft.cocoa": "קקאו",
  "block.minecraft.command_block": "בלוק פקודה",
  "block.minecraft.comparator": "משווה זרם רדסטון",
  "block.minecraft.composter": "מדשן",
  "block.minecraft.conduit": "ליבת מים",
  "block.minecraft.copper_bars": "סורגי נחושת",
  "block.minecraft.copper_block": "בלוק נחושת",
  "block.minecraft.copper_bulb": "נורת נחושת",
  "block.minecraft.copper_chain": "שרשרת נחושת",
  "block.minecraft.copper_chest": "תיבת נחושת",
  "block.minecraft.copper_door": "דלת נחושת",
  "block.minecraft.copper_golem_statue": "פסל גולם נחושת",
  "block.minecraft.copper_grate": "מגררת נחושת",
  "block.minecraft.copper_lantern": "עששית נחושת",
  "block.minecraft.copper_ore": "עפרת נחושת",
  "block.minecraft.copper_torch": "לפיד נחושת",
  "block.minecraft.copper_trapdoor": "דלת סתרים מנחושת",
  "block.minecraft.copper_wall_torch": "לפיד קיר נחושת",
  "block.minecraft.cornflower": "דרדר כחול",
  "block.minecraft.cracked_deepslate_bricks": "לבני לווחה סדוקות",
  "block.minecraft.cracked_deepslate_tiles": "אריחי לווחה סדוקים",
  "block.minecraft.cracked_nether_bricks": "לבני נד'ר סדוקות",
  "block.minecraft.cracked_polished_blackstone_bricks": "לבני אבן שחורה מלוטשת סדוקה",
  "block.minecraft.cracked_stone_bricks": "לבני אבן סדוקות",
  "block.minecraft.crafter": "יצרן",
  "block.minecraft.crafting_table": "שולחן מלאכה",
  "block.minecraft.creaking_heart": "לב חריקה",
  "block.minecraft.creeper_head": "ראש קריפר",
  "block.minecraft.creeper_wall_head": "ראש קריפר על הקיר",
  "block.minecraft.crimson_button": "כפתור מפטריית ארגמן",
  "block.minecraft.crimson_door": "דלת פטריית ארגמן",
  "block.minecraft.crimson_fence": "גדר פטריית ארגמן",
  "block.minecraft.crimson_fence_gate": "שער גדר פטריית ארגמן",
  "block.minecraft.crimson_fungus": "פטריית ארגמן",
  "block.minecraft.crimson_hanging_sign": "שלט תלוי מפטריית ארגמן",
  "block.minecraft.crimson_hyphae": "גדילי ארגמן",
  "block.minecraft.crimson_nylium": "נייליום ארגמן",
  "block.minecraft.crimson_planks": "קרשי פטריית ארגמן",
  "block.minecraft.crimson_pressure_plate": "לוחית לחץ מפטריית ארגמן",
  "block.minecraft.crimson_roots": "שורשי ארגמן",
  "block.minecraft.crimson_shelf": "מדף ארגמן",
  "block.minecraft.crimson_sign": "שלט מפטריית ארגמן",
  "block.minecraft.crimson_slab": "קרש פטריית ארגמן חצוי",
  "block.minecraft.crimson_stairs": "מדרגות פטריית ארגמן",
  "block.minecraft.crimson_stem": "גזע פטריית ארגמן",
  "block.minecraft.crimson_trapdoor": "דלת סתרים פטריית ארגמן",
  "block.minecraft.crimson_wall_hanging_sign": "שלט קיר תלוי מפטריית ארגמן",
  "block.minecraft.crimson_wall_sign": "שלט קיר פטריית ארגמן",
  "block.minecraft.crying_obsidian": "אובסידיאן בוכה",
  "block.minecraft.cut_copper": "לבני נחושת",
  "block.minecraft.cut_copper_slab": "לבנת נחושת חצויה",
  "block.minecraft.cut_copper_stairs": "מדרגות לבני נחושת",
  "block.minecraft.cut_red_sandstone": "אבן חול אדומה חתוכה",
  "block.minecraft.cut_red_sandstone_slab": "אבן חול אדומה חתוכה חצויה",
  "block.minecraft.cut_sandstone": "אבן חול חתוכה",
  "block.minecraft.cut_sandstone_slab": "אבן חול חתוכה חצויה",
  "block.minecraft.cyan_banner": "באנר ציאן",
  "block.minecraft.cyan_bed": "מיטה ציאן",
  "block.minecraft.cyan_candle": "נר ציאן",
  "block.minecraft.cyan_candle_cake": "עוגה עם נר ציאן",
  "block.minecraft.cyan_carpet": "שטיח ציאן",
  "block.minecraft.cyan_concrete": "בטון ציאן",
  "block.minecraft.cyan_concrete_powder": "אבקת בטון ציאן",
  "block.minecraft.cyan_glazed_terracotta": "טרקוטה מזוגגת ציאן",
  "block.minecraft.cyan_shulker_box": "תיבת שולקר ציאן",
  "block.minecraft.cyan_stained_glass": "זכוכית ציאן",
  "block.minecraft.cyan_stained_glass_pane": "זגוגית ציאן",
  "block.minecraft.cyan_terracotta": "טרקוטה ציאן",
  "block.minecraft.cyan_wool": "צמר ציאן",
  "block.minecraft.damaged_anvil": "סדן פגום",
  "block.minecraft.dandelion": "שן הארי",
  "block.minecraft.dark_oak_button": "כפתור מאלון כהה",
  "block.minecraft.dark_oak_door": "דלת אלון כהה",
  "block.minecraft.dark_oak_fence": "גדר אלון כהה",
  "block.minecraft.dark_oak_fence_gate": "שער גדר אלון כהה",
  "block.minecraft.dark_oak_hanging_sign": "שלט תלוי מאלון כהה",
  "block.minecraft.dark_oak_leaves": "עלי אלון כהה",
  "block.minecraft.dark_oak_log": "עץ אלון כהה",
  "block.minecraft.dark_oak_planks": "קרשי עץ אלון כהה",
  "block.minecraft.dark_oak_pressure_plate": "לוחית לחץ מאלון כהה",
  "block.minecraft.dark_oak_sapling": "שתיל אלון כהה",
  "block.minecraft.dark_oak_shelf": "מדף אלון כהה",
  "block.minecraft.dark_oak_sign": "שלט אלון כהה",
  "block.minecraft.dark_oak_slab": "קרש אלון כהה חצוי",
  "block.minecraft.dark_oak_stairs": "מדרגות אלון כהה",
  "block.minecraft.dark_oak_trapdoor": "דלת סתרים מאלון כהה",
  "block.minecraft.dark_oak_wall_hanging_sign": "שלט קיר תלוי מאלון כהה",
  "block.minecraft.dark_oak_wall_sign": "שלט קיר מאלון כהה",
  "block.minecraft.dark_oak_wood": "עץ אלון כהה",
  "block.minecraft.dark_prismarine": "פריזמרין כהה",
  "block.minecraft.dark_prismarine_slab": "פריזמרין כהה חצוי",
  "block.minecraft.dark_prismarine_stairs": "מדרגות פריזמרין כהה",
  "block.minecraft.daylight_detector": "חיישן אור יום",
  "block.minecraft.dead_brain_coral": "אלמוג מוחי מת",
  "block.minecraft.dead_brain_coral_block": "אלמוג מוחי מת",
  "block.minecraft.dead_brain_coral_fan": "ענף אלמוג מוחי מת",
  "block.minecraft.dead_brain_coral_wall_fan": "ענף קיר אלמוג מוחי מת",
  "block.minecraft.dead_bubble_coral": "אלמוג בועות מת",
  "block.minecraft.dead_bubble_coral_block": "אלמוג בועות מת",
  "block.minecraft.dead_bubble_coral_fan": "ענף אלמוג בועות מת",
  "block.minecraft.dead_bubble_coral_wall_fan": "ענף קיר אלמוג בועות מת",
  "block.minecraft.dead_bush": "שיח מת",
  "block.minecraft.dead_fire_coral": "אלמוג אש מת",
  "block.minecraft.dead_fire_coral_block": "אלמוג אש מת",
  "block.minecraft.dead_fire_coral_fan": "ענף אלמוג אש מת",
  "block.minecraft.dead_fire_coral_wall_fan": "ענף קיר אלמוג אש מת",
  "block.minecraft.dead_horn_coral": "אלמוג קרן מת",
  "block.minecraft.dead_horn_coral_block": "אלמוג קרן מת",
  "block.minecraft.dead_horn_coral_fan": "ענף אלמוג קרן מת",
  "block.minecraft.dead_horn_coral_wall_fan": "ענף קיר אלמוג קרן מת",
  "block.minecraft.dead_tube_coral": "אלמוג צינורי מת",
  "block.minecraft.dead_tube_coral_block": "אלמוג צינורי מת",
  "block.minecraft.dead_tube_coral_fan": "ענף אלמוג צינורי מת",
  "block.minecraft.dead_tube_coral_wall_fan": "ענף קיר אלמוג צינורי מת",
  "block.minecraft.decorated_pot": "כד מעוטר",
  "block.minecraft.deepslate": "לווחה",
  "block.minecraft.deepslate_brick_slab": "לבנת לווחה חצויה",
  "block.minecraft.deepslate_brick_stairs": "מדרגות לבני לווחה",
  "block.minecraft.deepslate_brick_wall": "קיר לבני לווחה",
  "block.minecraft.deepslate_bricks": "לבני לווחה",
  "block.minecraft.deepslate_coal_ore": "עפרת לווחת פחם",
  "block.minecraft.deepslate_copper_ore": "עפרת לווחת נחושת",
  "block.minecraft.deepslate_diamond_ore": "עפרת לווחת יהלום",
  "block.minecraft.deepslate_emerald_ore": "עפרת לווחת ברקת",
  "block.minecraft.deepslate_gold_ore": "עפרת לווחת זהב",
  "block.minecraft.deepslate_iron_ore": "עפרת לווחת ברזל",
  "block.minecraft.deepslate_lapis_ore": "עפרת לווחת לאפיס לאזולי",
  "block.minecraft.deepslate_redstone_ore": "עפרת לווחת רדסטון",
  "block.minecraft.deepslate_tile_slab": "אריח לווחה חצוי",
  "block.minecraft.deepslate_tile_stairs": "מדרגות אריחי לווחה",
  "block.minecraft.deepslate_tile_wall": "קיר אריחי לווחה",
  "block.minecraft.deepslate_tiles": "אריחי לווחה",
  "block.minecraft.detector_rail": "מסילת חיישן",
  "block.minecraft.diamond_block": "בלוק יהלום",
  "block.minecraft.diamond_ore": "עפרת יהלום",
  "block.minecraft.diorite": "דיוריט",
  "block.minecraft.diorite_slab": "דיוריט חצוי",
  "block.minecraft.diorite_stairs": "מדרגות דיוריט",
  "block.minecraft.diorite_wall": "קיר דיוריט",
  "block.minecraft.dirt": "עפר",
  "block.minecraft.dirt_path": "שביל עפר",
  "block.minecraft.dispenser": "זורקן",
  "block.minecraft.dragon_egg": "ביצת דרקון",
  "block.minecraft.dragon_head": "ראש דרקון",
  "block.minecraft.dragon_wall_head": "גולגולת דרקון על הקיר",
  "block.minecraft.dried_ghast": "גאסט מיובש",
  "block.minecraft.dried_kelp_block": "בלוק אצה מיובשת",
  "block.minecraft.dripstone_block": "בלוק אבן טפטוף",
  "block.minecraft.dropper": "פולטן",
  "block.minecraft.emerald_block": "בלוק ברקת",
  "block.minecraft.emerald_ore": "עפרת ברקת",
  "block.minecraft.enchanting_table": "שולחן כישוף",
  "block.minecraft.end_gateway": "שער האנד",
  "block.minecraft.end_portal": "שער אנד",
  "block.minecraft.end_portal_frame": "מסגרת שער אנד",
  "block.minecraft.end_rod": "מוט אנד",
  "block.minecraft.end_stone": "אבן אנד",
  "block.minecraft.end_stone_brick_slab": "לבני אבן אנד חצויות",
  "block.minecraft.end_stone_brick_stairs": "מדרגות לבני אבן אנד",
  "block.minecraft.end_stone_brick_wall": "קיר לבני אבן אנד",
  "block.minecraft.end_stone_bricks": "לבני אבן אנד",
  "block.minecraft.ender_chest": "תיבת אנדר",
  "block.minecraft.exposed_chiseled_copper": "נחושת חשופה מפוסלת",
  "block.minecraft.exposed_copper": "נחושת חשופה",
  "block.minecraft.exposed_copper_bars": "סורגי נחושת חשופה",
  "block.minecraft.exposed_copper_bulb": "נורת נחושת חשופה",
  "block.minecraft.exposed_copper_chain": "שרשרת נחושת חשופה",
  "block.minecraft.exposed_copper_chest": "תיבת נחושת חשופה",
  "block.minecraft.exposed_copper_door": "דלת נחושת חשופה",
  "block.minecraft.exposed_copper_golem_statue": "פסל גולם מנחושת חשופה",
  "block.minecraft.exposed_copper_grate": "מגררת נחושת חשופה",
  "block.minecraft.exposed_copper_lantern": "עששית נחושת חשופה",
  "block.minecraft.exposed_copper_trapdoor": "דלת סתרים מנחושת חשופה",
  "block.minecraft.exposed_cut_copper": "לבני נחושת חשופות",
  "block.minecraft.exposed_cut_copper_slab": "לבנת נחושת חשופה חצויה",
  "block.minecraft.exposed_cut_copper_stairs": "מדרגות לבני נחושת חשופות",
  "block.minecraft.exposed_lightning_rod": "כליא ברק חשוף",
  "block.minecraft.farmland": "ערוגה",
  "block.minecraft.fern": "שרך",
  "block.minecraft.fire": "אש",
  "block.minecraft.fire_coral": "צמח אלמוג אש",
  "block.minecraft.fire_coral_block": "אלמוג אש",
  "block.minecraft.fire_coral_fan": "ענף אלמוג אש",
  "block.minecraft.fire_coral_wall_fan": "ענף קיר אלמוג אש",
  "block.minecraft.firefly_bush": "שיח גחליליות",
  "block.minecraft.fletching_table": "שולחן הכנת חיצים",
  "block.minecraft.flower_pot": "עציץ",
  "block.minecraft.flowering_azalea": "אזליאה פורחת",
  "block.minecraft.flowering_azalea_leaves": "עלי אזליאה פורחת",
  "block.minecraft.frogspawn": "שרצת צפרדע",
  "block.minecraft.frosted_ice": "קרח קפוא",
  "block.minecraft.furnace": "תנור",
  "block.minecraft.gilded_blackstone": "אבן שחורה מוזהבת",
  "block.minecraft.glass": "זכוכית",
  "block.minecraft.glass_pane": "זגוגית",
  "block.minecraft.glow_lichen": "חזזית זוהרת",
  "block.minecraft.glowstone": "אבן זוהרת",
  "block.minecraft.gold_block": "בלוק זהב",
  "block.minecraft.gold_ore": "עפרת זהב",
  "block.minecraft.golden_dandelion": "שן הארי מוזהב",
  "block.minecraft.granite": "גרניט",
  "block.minecraft.granite_slab": "גרניט חצוי",
  "block.minecraft.granite_stairs": "מדרגות גרניט",
  "block.minecraft.granite_wall": "קיר גרניט",
  "block.minecraft.grass": "דשא",
  "block.minecraft.grass_block": "בלוק דשא",
  "block.minecraft.gravel": "חצץ",
  "block.minecraft.gray_banner": "באנר אפור",
  "block.minecraft.gray_bed": "מיטה אפורה",
  "block.minecraft.gray_candle": "נר אפור",
  "block.minecraft.gray_candle_cake": "עוגה עם נר אפור",
  "block.minecraft.gray_carpet": "שטיח אפור",
  "block.minecraft.gray_concrete": "בטון אפור",
  "block.minecraft.gray_concrete_powder": "אבקת בטון אפורה",
  "block.minecraft.gray_glazed_terracotta": "טרקוטה מזוגגת אפורה",
  "block.minecraft.gray_shulker_box": "תיבת שולקר אפורה",
  "block.minecraft.gray_stained_glass": "זכוכית אפורה",
  "block.minecraft.gray_stained_glass_pane": "זגוגית אפורה",
  "block.minecraft.gray_terracotta": "טרקוטה אפורה",
  "block.minecraft.gray_wool": "צמר אפור",
  "block.minecraft.green_banner": "באנר ירוק",
  "block.minecraft.green_bed": "מיטה ירוקה",
  "block.minecraft.green_candle": "נר ירוק",
  "block.minecraft.green_candle_cake": "עוגה עם נר ירוק",
  "block.minecraft.green_carpet": "שטיח ירוק",
  "block.minecraft.green_concrete": "בטון ירוק",
  "block.minecraft.green_concrete_powder": "אבקת בטון ירוקה",
  "block.minecraft.green_glazed_terracotta": "טרקוטה מזוגגת ירוקה",
  "block.minecraft.green_shulker_box": "תיבת שולקר ירוקה",
  "block.minecraft.green_stained_glass": "זכוכית ירוקה",
  "block.minecraft.green_stained_glass_pane": "זגוגית ירוקה",
  "block.minecraft.green_terracotta": "טרקוטה ירוקה",
  "block.minecraft.green_wool": "צמר ירוק",
  "block.minecraft.grindstone": "אבן משחזת",
  "block.minecraft.hanging_roots": "שורשי אוויר",
  "block.minecraft.hay_block": "ערמת חציר",
  "block.minecraft.heavy_core": "ליבה כבדה",
  "block.minecraft.heavy_weighted_pressure_plate": "לוחית לחץ כבדת משקל",
  "block.minecraft.honey_block": "בלוק דבש",
  "block.minecraft.honeycomb_block": "בלוק חלת דבש",
  "block.minecraft.hopper": "משפך",
  "block.minecraft.horn_coral": "צמח אלמוג קרן",
  "block.minecraft.horn_coral_block": "אלמוג קרן",
  "block.minecraft.horn_coral_fan": "ענף אלמוג קרן",
  "block.minecraft.horn_coral_wall_fan": "ענף קיר אלמוג קרן",
  "block.minecraft.ice": "קרח",
  "block.minecraft.infested_chiseled_stone_bricks": "לבני אבן מלוטשות נגועות",
  "block.minecraft.infested_cobblestone": "אבן מרוסקת נגועה",
  "block.minecraft.infested_cracked_stone_bricks": "לבני אבן סדוקות נגועות",
  "block.minecraft.infested_deepslate": "לווחה נגועה",
  "block.minecraft.infested_mossy_stone_bricks": "לבני אבן טחב נגועות",
  "block.minecraft.infested_stone": "אבן נגועה",
  "block.minecraft.infested_stone_bricks": "לבני אבן נגועות",
  "block.minecraft.iron_bars": "סורגי ברזל",
  "block.minecraft.iron_block": "בלוק ברזל",
  "block.minecraft.iron_chain": "שרשרת ברזל",
  "block.minecraft.iron_door": "דלת ברזל",
  "block.minecraft.iron_ore": "עפרת ברזל",
  "block.minecraft.iron_trapdoor": "דלת סתרים מברזל",
  "block.minecraft.jack_o_lantern": "מנורת דלעת",
  "block.minecraft.jigsaw": "בלוק פאזל",
  "block.minecraft.jukebox": "תיבת נגינה",
  "block.minecraft.jungle_button": "כפתור מעץ ג'ונגל",
  "block.minecraft.jungle_door": "דלת עץ ג'ונגל",
  "block.minecraft.jungle_fence": "גדר עץ ג'ונגל",
  "block.minecraft.jungle_fence_gate": "שער גדר עץ ג'ונגל",
  "block.minecraft.jungle_hanging_sign": "שלט תלוי מעץ ג'ונגל",
  "block.minecraft.jungle_leaves": "עלי ג'ונגל",
  "block.minecraft.jungle_log": "עץ ג'ונגל",
  "block.minecraft.jungle_planks": "קרשי עץ ג'ונגל",
  "block.minecraft.jungle_pressure_plate": "לוחית לחץ מעץ ג'ונגל",
  "block.minecraft.jungle_sapling": "שתיל ג'ונגל",
  "block.minecraft.jungle_shelf": "מדף עץ ג'ונגל",
  "block.minecraft.jungle_sign": "שלט עץ ג'ונגל",
  "block.minecraft.jungle_slab": "קרש עץ ג'ונגל חצוי",
  "block.minecraft.jungle_stairs": "מדרגות עץ ג'ונגל",
  "block.minecraft.jungle_trapdoor": "דלת סתרים מעץ ג'ונגל",
  "block.minecraft.jungle_wall_hanging_sign": "שלט קיר תלוי מעץ ג'ונגל",
  "block.minecraft.jungle_wall_sign": "שלט קיר מעץ ג'ונגל",
  "block.minecraft.jungle_wood": "עץ ג'ונגל",
  "block.minecraft.kelp": "אצה",
  "block.minecraft.kelp_plant": "צמח אצה",
  "block.minecraft.ladder": "סולם",
  "block.minecraft.lantern": "עששית",
  "block.minecraft.lapis_block": "בלוק לאפיס לאזולי",
  "block.minecraft.lapis_ore": "עפרת לאפיס לאזולי",
  "block.minecraft.large_amethyst_bud": "ניצן אחלמה גדול",
  "block.minecraft.large_fern": "שרך גדול",
  "block.minecraft.lava": "לבה",
  "block.minecraft.lava_cauldron": "קדרת לבה",
  "block.minecraft.leaf_litter": "ערימת עלים",
  "block.minecraft.lectern": "מעמד ספרים",
  "block.minecraft.lever": "מפסק",
  "block.minecraft.light": "אור",
  "block.minecraft.light_blue_banner": "באנר תכלת",
  "block.minecraft.light_blue_bed": "מיטה תכלת",
  "block.minecraft.light_blue_candle": "נר תכלת",
  "block.minecraft.light_blue_candle_cake": "עוגה עם נר תכלת",
  "block.minecraft.light_blue_carpet": "שטיח תכלת",
  "block.minecraft.light_blue_concrete": "בטון תכלת",
  "block.minecraft.light_blue_concrete_powder": "אבקת בטון תכלת",
  "block.minecraft.light_blue_glazed_terracotta": "טרקוטה מזוגגת תכלת",
  "block.minecraft.light_blue_shulker_box": "תיבת שולקר תכלת",
  "block.minecraft.light_blue_stained_glass": "זכוכית כחולה בהירה",
  "block.minecraft.light_blue_stained_glass_pane": "זגוגית תכלת",
  "block.minecraft.light_blue_terracotta": "טרקוטה תכלת",
  "block.minecraft.light_blue_wool": "צמר תכלת",
  "block.minecraft.light_gray_banner": "באנר אפור בהיר",
  "block.minecraft.light_gray_bed": "מיטה אפורה בהירה",
  "block.minecraft.light_gray_candle": "נר אפור בהיר",
  "block.minecraft.light_gray_candle_cake": "עוגה עם נר אפור בהיר",
  "block.minecraft.light_gray_carpet": "שטיח אפור בהיר",
  "block.minecraft.light_gray_concrete": "בטון אפור בהיר",
  "block.minecraft.light_gray_concrete_powder": "אבקת בטון אפורה בהירה",
  "block.minecraft.light_gray_glazed_terracotta": "טרקוטה מזוגגת אפורה בהירה",
  "block.minecraft.light_gray_shulker_box": "תיבת שולקר אפורה בהירה",
  "block.minecraft.light_gray_stained_glass": "זכוכית אפורה בהירה",
  "block.minecraft.light_gray_stained_glass_pane": "זגוגית אפורה בהירה",
  "block.minecraft.light_gray_terracotta": "טרקוטה אפורה בהירה",
  "block.minecraft.light_gray_wool": "צמר אפור בהיר",
  "block.minecraft.light_weighted_pressure_plate": "לוחית לחץ קלת משקל",
  "block.minecraft.lightning_rod": "כליא ברק",
  "block.minecraft.lilac": "לילך",
  "block.minecraft.lily_of_the_valley": "שושנת העמקים",
  "block.minecraft.lily_pad": "נופר",
  "block.minecraft.lime_banner": "באנר ליים",
  "block.minecraft.lime_bed": "מיטה ליים",
  "block.minecraft.lime_candle": "נר ליים",
  "block.minecraft.lime_candle_cake": "עוגה עם נר ליים",
  "block.minecraft.lime_carpet": "שטיח ליים",
  "block.minecraft.lime_concrete": "בטון ליים",
  "block.minecraft.lime_concrete_powder": "אבקת בטון ליים",
  "block.minecraft.lime_glazed_terracotta": "טרקוטה מזוגגת ליים",
  "block.minecraft.lime_shulker_box": "תיבת שולקר ליים",
  "block.minecraft.lime_stained_glass": "זכוכית ליים",
  "block.minecraft.lime_stained_glass_pane": "זגוגית ליים",
  "block.minecraft.lime_terracotta": "טרקוטה ליים",
  "block.minecraft.lime_wool": "צמר ליים",
  "block.minecraft.lodestone": "מגנטיט",
  "block.minecraft.loom": "נול",
  "block.minecraft.magenta_banner": "באנר מג'נטה",
  "block.minecraft.magenta_bed": "מיטה מג'נטה",
  "block.minecraft.magenta_candle": "נר מג'נטה",
  "block.minecraft.magenta_candle_cake": "עוגה עם נר מג'נטה",
  "block.minecraft.magenta_carpet": "שטיח מג'נטה",
  "block.minecraft.magenta_concrete": "בטון מג'נטה",
  "block.minecraft.magenta_concrete_powder": "אבקת בטון מג'נטה",
  "block.minecraft.magenta_glazed_terracotta": "טרקוטה מזוגגת מג'נטה",
  "block.minecraft.magenta_shulker_box": "תיבת שולקר מג'נטה",
  "block.minecraft.magenta_stained_glass": "זכוכית מג'נטה",
  "block.minecraft.magenta_stained_glass_pane": "זגוגית מג'נטה",
  "block.minecraft.magenta_terracotta": "טרקוטה מג'נטה",
  "block.minecraft.magenta_wool": "צמר מג'נטה",
  "block.minecraft.magma_block": "קוביית מאגמה",
  "block.minecraft.mangrove_button": "כפתור ממנגרוב",
  "block.minecraft.mangrove_door": "דלת מנגרוב",
  "block.minecraft.mangrove_fence": "גדר מנגרוב",
  "block.minecraft.mangrove_fence_gate": "שער גדר מנגרוב",
  "block.minecraft.mangrove_hanging_sign": "שלט תלוי ממנגרוב",
  "block.minecraft.mangrove_leaves": "עלי מנגרוב",
  "block.minecraft.mangrove_log": "עץ מנגרוב",
  "block.minecraft.mangrove_planks": "קרשי עץ מנגרוב",
  "block.minecraft.mangrove_pressure_plate": "לוחית לחץ ממנגרוב",
  "block.minecraft.mangrove_propagule": "יחידת תפוצה ממנגרוב",
  "block.minecraft.mangrove_roots": "שורשי מנגרוב",
  "block.minecraft.mangrove_shelf": "מדף מנגרוב",
  "block.minecraft.mangrove_sign": "שלט מנגרוב",
  "block.minecraft.mangrove_slab": "קרש מנגרוב חצוי",
  "block.minecraft.mangrove_stairs": "מדרגות מנגרוב",
  "block.minecraft.mangrove_trapdoor": "דלת סתרים ממנגרוב",
  "block.minecraft.mangrove_wall_hanging_sign": "שלט קיר תלוי ממנגרוב",
  "block.minecraft.mangrove_wall_sign": "שלט קיר ממנגרוב",
  "block.minecraft.mangrove_wood": "עץ מנגרוב",
  "block.minecraft.medium_amethyst_bud": "ניצן אחלמה",
  "block.minecraft.melon": "אבטיח",
  "block.minecraft.melon_stem": "גזע אבטיח",
  "block.minecraft.moss_block": "בלוק טחב",
  "block.minecraft.moss_carpet": "שטיח טחב",
  "block.minecraft.mossy_cobblestone": "אבן טחב מרוסקת",
  "block.minecraft.mossy_cobblestone_slab": "אבן טחב מרוסקת חצויה",
  "block.minecraft.mossy_cobblestone_stairs": "מדרגות אבן טחב מרוסקת",
  "block.minecraft.mossy_cobblestone_wall": "חומת אבן טחב מרוסקת ",
  "block.minecraft.mossy_stone_brick_slab": "לבני אבן טחב חצויות",
  "block.minecraft.mossy_stone_brick_stairs": "מדרגות לבני אבן טחב",
  "block.minecraft.mossy_stone_brick_wall": "קיר לבני אבן טחב",
  "block.minecraft.mossy_stone_bricks": "לבני אבן טחב",
  "block.minecraft.moving_piston": "בוכנה זזה",
  "block.minecraft.mud": "בוץ",
  "block.minecraft.mud_brick_slab": "לבנת בוץ חצויה",
  "block.minecraft.mud_brick_stairs": "מדרגות לבני בוץ",
  "block.minecraft.mud_brick_wall": "קיר לבני בוץ",
  "block.minecraft.mud_bricks": "לבני בוץ",
  "block.minecraft.muddy_mangrove_roots": "שורשי מנגרוב בוציים",
  "block.minecraft.mushroom_stem": "גזע פטריה",
  "block.minecraft.mycelium": "תפטיר",
  "block.minecraft.nether_brick_fence": "גדר לבנת נד'ר",
  "block.minecraft.nether_brick_slab": "לבנת נד'ר חצויה",
  "block.minecraft.nether_brick_stairs": "מדרגות לבנת נד'ר",
  "block.minecraft.nether_brick_wall": "קיר לבנת נד'ר",
  "block.minecraft.nether_bricks": "לבני נד'ר",
  "block.minecraft.nether_gold_ore": "עפרת זהב נד'ר",
  "block.minecraft.nether_portal": "שער לנד'ר",
  "block.minecraft.nether_quartz_ore": "עפרת קוורץ נד'ר",
  "block.minecraft.nether_sprouts": "נבטי נד'ר",
  "block.minecraft.nether_wart": "שיבולת נד'ר",
  "block.minecraft.nether_wart_block": "בלוק שיבולת נד'ר",
  "block.minecraft.netherite_block": "בלוק נד'רייט",
  "block.minecraft.netherrack": "נד'רראק",
  "block.minecraft.note_block": "בלוק צליל",
  "block.minecraft.oak_button": "כפתור מאלון",
  "block.minecraft.oak_door": "דלת אלון",
  "block.minecraft.oak_fence": "גדר אלון",
  "block.minecraft.oak_fence_gate": "שער גדר אלון",
  "block.minecraft.oak_hanging_sign": "שלט תלוי מאלון",
  "block.minecraft.oak_leaves": "עלי אלון",
  "block.minecraft.oak_log": "עץ אלון",
  "block.minecraft.oak_planks": "קרשי עץ אלון",
  "block.minecraft.oak_pressure_plate": "לוחית לחץ מאלון",
  "block.minecraft.oak_sapling": "שתיל אלון",
  "block.minecraft.oak_shelf": "מדף אלון",
  "block.minecraft.oak_sign": "שלט אלון",
  "block.minecraft.oak_slab": "קרש אלון חצוי",
  "block.minecraft.oak_stairs": "מדרגות אלון",
  "block.minecraft.oak_trapdoor": "דלת סתרים מאלון",
  "block.minecraft.oak_wall_hanging_sign": "שלט קיר תלוי מאלון",
  "block.minecraft.oak_wall_sign": "שלט קיר מאלון",
  "block.minecraft.oak_wood": "עץ אלון",
  "block.minecraft.observer": "תצפיתן",
  "block.minecraft.obsidian": "אובסידיאן",
  "block.minecraft.ochre_froglight": "מנורת צפרדע אוכרה",
  "block.minecraft.ominous_banner": "דגל מאיים",
  "block.minecraft.open_eyeblossom": "עינית לילה פתוחה",
  "block.minecraft.orange_banner": "באנר כתום",
  "block.minecraft.orange_bed": "מיטה כתומה",
  "block.minecraft.orange_candle": "נר כתום",
  "block.minecraft.orange_candle_cake": "עוגה עם נר כתום",
  "block.minecraft.orange_carpet": "שטיח כתום",
  "block.minecraft.orange_concrete": "בטון כתום",
  "block.minecraft.orange_concrete_powder": "אבקת בטון כתומה",
  "block.minecraft.orange_glazed_terracotta": "טרקוטה מזוגגת כתומה",
  "block.minecraft.orange_shulker_box": "תיבת שולקר כתומה",
  "block.minecraft.orange_stained_glass": "זכוכית כתומה",
  "block.minecraft.orange_stained_glass_pane": "זגוגית כתומה",
  "block.minecraft.orange_terracotta": "טרקוטה כתומה",
  "block.minecraft.orange_tulip": "צבעוני כתום",
  "block.minecraft.orange_wool": "צמר כתום",
  "block.minecraft.oxeye_daisy": "חרצית לבנה",
  "block.minecraft.oxidized_chiseled_copper": "לבני נחושת מפוסלות מחומצנות",
  "block.minecraft.oxidized_copper": "נחושת מחומצנת",
  "block.minecraft.oxidized_copper_bars": "סורגי נחושת מחומצנת",
  "block.minecraft.oxidized_copper_bulb": "נורת נחושת מחומצנת",
  "block.minecraft.oxidized_copper_chain": "שרשרת נחושת מחומצנת",
  "block.minecraft.oxidized_copper_chest": "תיבה נחושת מחומצנת",
  "block.minecraft.oxidized_copper_door": "דלת נחושת מחומצנת",
  "block.minecraft.oxidized_copper_golem_statue": "פסל גולם מנחושת מחומצנת",
  "block.minecraft.oxidized_copper_grate": "מגררת נחושת מחומצנת",
  "block.minecraft.oxidized_copper_lantern": "עששית נחושת מחומצנת",
  "block.minecraft.oxidized_copper_trapdoor": "דלת סתרים נחושת מחומצנת",
  "block.minecraft.oxidized_cut_copper": "לבני נחושת מחומצנות",
  "block.minecraft.oxidized_cut_copper_slab": "לבנת נחושת מחומצנת חצויה",
  "block.minecraft.oxidized_cut_copper_stairs": "מדרגות לבני נחושת מחומצנות",
  "block.minecraft.oxidized_lightning_rod": "כליא ברק מחומצן",
  "block.minecraft.packed_ice": "קרח דחוס",
  "block.minecraft.packed_mud": "בוץ דחוס",
  "block.minecraft.pale_hanging_moss": "טחב חיוור תלוי",
  "block.minecraft.pale_moss_block": "בלוק טחב חיוור",
  "block.minecraft.pale_moss_carpet": "שטיח טחב חיוור",
  "block.minecraft.pale_oak_button": "כפתור אלון חיוור",
  "block.minecraft.pale_oak_door": "דלת אלון חיוור",
  "block.minecraft.pale_oak_fence": "גדר אלון חיוור",
  "block.minecraft.pale_oak_fence_gate": "שער גדר אלון חיוור",
  "block.minecraft.pale_oak_hanging_sign": "שלט תלוי מאלון חיוור",
  "block.minecraft.pale_oak_leaves": "עלי אלון חיוור",
  "block.minecraft.pale_oak_log": "גזע אלון חיוור",
  "block.minecraft.pale_oak_planks": "קרשי אלון חיוור",
  "block.minecraft.pale_oak_pressure_plate": "לוחית לחץ אלון חיוור",
  "block.minecraft.pale_oak_sapling": "שתיל עץ אלון חיוור",
  "block.minecraft.pale_oak_shelf": "מדף אלון חיוור",
  "block.minecraft.pale_oak_sign": "שלט אלון חיוור",
  "block.minecraft.pale_oak_slab": "קרש אלון חיוור חצוי",
  "block.minecraft.pale_oak_stairs": "מדרגות אלון חיוור",
  "block.minecraft.pale_oak_trapdoor": "דלת סתרים אלון חיוור",
  "block.minecraft.pale_oak_wall_hanging_sign": "שלט קיר תלוי מאלון חיוור",
  "block.minecraft.pale_oak_wall_sign": "שלט קיר אלון חיוור",
  "block.minecraft.pale_oak_wood": "עץ אלון חיוור",
  "block.minecraft.pearlescent_froglight": "מנורת צפרדע פנינה",
  "block.minecraft.peony": "אדמונית ורודה",
  "block.minecraft.petrified_oak_slab": "אלון מאובן חצוי",
  "block.minecraft.piglin_head": "ראש פיגלין",
  "block.minecraft.piglin_wall_head": "ראש פיגלין על הקיר",
  "block.minecraft.pink_banner": "באנר ורוד",
  "block.minecraft.pink_bed": "מיטה ורודה",
  "block.minecraft.pink_candle": "נר ורוד",
  "block.minecraft.pink_candle_cake": "עוגה עם נר ורוד",
  "block.minecraft.pink_carpet": "שטיח ורוד",
  "block.minecraft.pink_concrete": "בטון ורוד",
  "block.minecraft.pink_concrete_powder": "אבקת בטון ורודה",
  "block.minecraft.pink_glazed_terracotta": "טרקוטה מזוגגת ורודה",
  "block.minecraft.pink_petals": "עלי כותרת ורודים",
  "block.minecraft.pink_shulker_box": "תיבת שולקר ורודה",
  "block.minecraft.pink_stained_glass": "זכוכית ורודה",
  "block.minecraft.pink_stained_glass_pane": "זגוגית ורודה",
  "block.minecraft.pink_terracotta": "טרקוטה ורודה",
  "block.minecraft.pink_tulip": "צבעוני ורוד",
  "block.minecraft.pink_wool": "צמר ורוד",
  "block.minecraft.piston": "בוכנה",
  "block.minecraft.piston_head": "ראש בוכנה",
  "block.minecraft.pitcher_crop": "יבול כדנית",
  "block.minecraft.pitcher_plant": "צמח כדנית",
  "block.minecraft.player_head": "ראש שחקן",
  "block.minecraft.player_head.named": "הראש של %s",
  "block.minecraft.player_wall_head": "ראש שחקן על הקיר",
  "block.minecraft.podzol": "פודזול",
  "block.minecraft.pointed_dripstone": "אבן טפטוף מחודדת",
  "block.minecraft.polished_andesite": "אנדזיט מלוטש",
  "block.minecraft.polished_andesite_slab": "אנזיט מלוטש חצוי",
  "block.minecraft.polished_andesite_stairs": "מדרגות אנזיט מלוטש",
  "block.minecraft.polished_basalt": "בזלת מלוטשת",
  "block.minecraft.polished_blackstone": "אבן שחורה מלוטשת",
  "block.minecraft.polished_blackstone_brick_slab": "לבני אבן שחורה מלוטשת חצויות",
  "block.minecraft.polished_blackstone_brick_stairs": "מדרגות לבני אבן שחורה מלוטשת",
  "block.minecraft.polished_blackstone_brick_wall": "קיר לבני אבן שחורה מלוטשת",
  "block.minecraft.polished_blackstone_bricks": "לבני אבן שחורה מלוטשת",
  "block.minecraft.polished_blackstone_button": "כפתור מאבן שחורה מלוטשת",
  "block.minecraft.polished_blackstone_pressure_plate": "לוחית לחץ מאבן שחורה מלוטשת",
  "block.minecraft.polished_blackstone_slab": "אבן שחורה מלוטשת חצויה",
  "block.minecraft.polished_blackstone_stairs": "מדרגות אבן שחורה מלוטשת",
  "block.minecraft.polished_blackstone_wall": "קיר אבן שחורה מלוטשת",
  "block.minecraft.polished_deepslate": "לווחה מלוטשת",
  "block.minecraft.polished_deepslate_slab": "לווחה מלוטשת חצויה",
  "block.minecraft.polished_deepslate_stairs": "מדרגות לווחה מלוטשת",
  "block.minecraft.polished_deepslate_wall": "קיר לווחה מלוטשת",
  "block.minecraft.polished_diorite": "דיוריט מלוטש",
  "block.minecraft.polished_diorite_slab": "דיוריט מלוטש חצוי",
  "block.minecraft.polished_diorite_stairs": "מדרגות דיוריט מלוטש",
  "block.minecraft.polished_granite": "גרניט מלוטש",
  "block.minecraft.polished_granite_slab": "גרניט מלוטש חצוי",
  "block.minecraft.polished_granite_stairs": "מדרגות גרניט מלוטש",
  "block.minecraft.polished_tuff": "טוף מלוטש",
  "block.minecraft.polished_tuff_slab": "טוף מלוטש חצוי",
  "block.minecraft.polished_tuff_stairs": "מדרגות טוף מלוטש",
  "block.minecraft.polished_tuff_wall": "קיר טוף מלוטש",
  "block.minecraft.poppy": "פרג",
  "block.minecraft.potatoes": "תפוחי אדמה",
  "block.minecraft.potted_acacia_sapling": "עציץ עץ שיטה",
  "block.minecraft.potted_allium": "עציץ שום",
  "block.minecraft.potted_azalea_bush": "עציץ אזליאה",
  "block.minecraft.potted_azure_bluet": "עציץ פרח בר כחול",
  "block.minecraft.potted_bamboo": "במבוק שתול",
  "block.minecraft.potted_birch_sapling": "עציץ עץ שדר",
  "block.minecraft.potted_blue_orchid": "עציץ סחלב כחול",
  "block.minecraft.potted_brown_mushroom": "עציץ פטריה חומה",
  "block.minecraft.potted_cactus": "עציץ קקטוס",
  "block.minecraft.potted_cherry_sapling": "עציץ עץ דובדבן",
  "block.minecraft.potted_closed_eyeblossom": "עציץ עינית לילה סגורה",
  "block.minecraft.potted_cornflower": "דרדר כחול שתול",
  "block.minecraft.potted_crimson_fungus": "פטריית ארגמן שתולה",
  "block.minecraft.potted_crimson_roots": "שורשי ארגמן שתולים",
  "block.minecraft.potted_dandelion": "עציץ שן הארי",
  "block.minecraft.potted_dark_oak_sapling": "עציץ עץ אלון כהה",
  "block.minecraft.potted_dead_bush": "עציץ שיח מת",
  "block.minecraft.potted_fern": "עציץ שרך",
  "block.minecraft.potted_flowering_azalea_bush": "עציץ אזליאה פורחת",
  "block.minecraft.potted_golden_dandelion": "עציץ שן הארי מוזהב",
  "block.minecraft.potted_jungle_sapling": "עציץ עץ ג'ונגל",
  "block.minecraft.potted_lily_of_the_valley": "שושנת העמקים שתולה",
  "block.minecraft.potted_mangrove_propagule": "יחידת תפוצה ממנגרוב בעציץ",
  "block.minecraft.potted_oak_sapling": "עציץ עץ אלון",
  "block.minecraft.potted_open_eyeblossom": "עציץ עינית לילה פתוחה",
  "block.minecraft.potted_orange_tulip": "עציץ צבעוני כתום",
  "block.minecraft.potted_oxeye_daisy": "עציץ חרצית לבנה",
  "block.minecraft.potted_pale_oak_sapling": "שתיל אלון חיוור שתול",
  "block.minecraft.potted_pink_tulip": "עציץ צבעוני ורוד",
  "block.minecraft.potted_poppy": "עציץ פרג",
  "block.minecraft.potted_red_mushroom": "עציץ פטריה אדומה",
  "block.minecraft.potted_red_tulip": "עציץ צבעוני אדום",
  "block.minecraft.potted_spruce_sapling": "עציץ עץ אשוחית",
  "block.minecraft.potted_torchflower": "פרח לפיד בעציץ",
  "block.minecraft.potted_warped_fungus": "פטריה מעוותת שתולה",
  "block.minecraft.potted_warped_roots": "שורשים מעוותים שתולים",
  "block.minecraft.potted_white_tulip": "עציץ צבעוני לבן",
  "block.minecraft.potted_wither_rose": "ורד וויד'ר שתול",
  "block.minecraft.powder_snow": "אבקת שלג",
  "block.minecraft.powder_snow_cauldron": "קדירת אבקת שלג",
  "block.minecraft.powered_rail": "מסילה ממונעת",
  "block.minecraft.prismarine": "פריזמרין",
  "block.minecraft.prismarine_brick_slab": "לבנת פריזמרין חצויה",
  "block.minecraft.prismarine_brick_stairs": "מדרגות לבנת פריזמרין",
  "block.minecraft.prismarine_bricks": "לבני פריזמרין",
  "block.minecraft.prismarine_slab": "פריזמרין חצוי",
  "block.minecraft.prismarine_stairs": "מדרגות פריזמרין",
  "block.minecraft.prismarine_wall": "קיר פריזמרין",
  "block.minecraft.pumpkin": "דלעת",
  "block.minecraft.pumpkin_stem": "גזע דלעת",
  "block.minecraft.purple_banner": "באנר סגול",
  "block.minecraft.purple_bed": "מיטה סגולה",
  "block.minecraft.purple_candle": "נר סגול",
  "block.minecraft.purple_candle_cake": "עוגה עם נר סגול",
  "block.minecraft.purple_carpet": "שטיח סגול",
  "block.minecraft.purple_concrete": "בטון סגול",
  "block.minecraft.purple_concrete_powder": "אבקת בטון סגולה",
  "block.minecraft.purple_glazed_terracotta": "טרקוטה מזוגגת סגולה",
  "block.minecraft.purple_shulker_box": "תיבת שולקר סגולה",
  "block.minecraft.purple_stained_glass": "זכוכית סגולה",
  "block.minecraft.purple_stained_glass_pane": "זגוגית סגולה",
  "block.minecraft.purple_terracotta": "טרקוטה סגולה",
  "block.minecraft.purple_wool": "צמר סגול",
  "block.minecraft.purpur_block": "בלוק פורפור",
  "block.minecraft.purpur_pillar": "עמוד פורפור",
  "block.minecraft.purpur_slab": "פורפור חצוי",
  "block.minecraft.purpur_stairs": "מדרגות פורפור",
  "block.minecraft.quartz_block": "בלוק קוורץ",
  "block.minecraft.quartz_bricks": "לבני קוורץ",
  "block.minecraft.quartz_pillar": "עמוד קוורץ",
  "block.minecraft.quartz_slab": "קוורץ חצוי",
  "block.minecraft.quartz_stairs": "מדרגות קוורץ",
  "block.minecraft.rail": "מסילה",
  "block.minecraft.raw_copper_block": "בלוק נחושת גולמית",
  "block.minecraft.raw_gold_block": "בלוק זהב גולמי",
  "block.minecraft.raw_iron_block": "בלוק ברזל גולמי",
  "block.minecraft.red_banner": "באנר אדום",
  "block.minecraft.red_bed": "מיטה אדומה",
  "block.minecraft.red_candle": "נר אדום",
  "block.minecraft.red_candle_cake": "עוגה עם נר אדום",
  "block.minecraft.red_carpet": "שטיח אדום",
  "block.minecraft.red_concrete": "בטון אדום",
  "block.minecraft.red_concrete_powder": "אבקת בטון אדומה",
  "block.minecraft.red_glazed_terracotta": "טרקוטה מזוגגת אדומה",
  "block.minecraft.red_mushroom": "פטרייה אדומה",
  "block.minecraft.red_mushroom_block": "בלוק פטריה אדומה",
  "block.minecraft.red_nether_brick_slab": "לבני נד'ר אדומות חצויות",
  "block.minecraft.red_nether_brick_stairs": "מדרגות לבני נד'ר אדומות",
  "block.minecraft.red_nether_brick_wall": "קיר לבני נד'ר אדומות",
  "block.minecraft.red_nether_bricks": "לבני נד'ר אדומות",
  "block.minecraft.red_sand": "חול אדום",
  "block.minecraft.red_sandstone": "אבן חול אדומה",
  "block.minecraft.red_sandstone_slab": "אבן חול אדומה חצויה",
  "block.minecraft.red_sandstone_stairs": "מדרגות אבן חול אדומה",
  "block.minecraft.red_sandstone_wall": "קיר אבן חול אדומה",
  "block.minecraft.red_shulker_box": "תיבת שולקר אדומה",
  "block.minecraft.red_stained_glass": "זכוכית אדומה",
  "block.minecraft.red_stained_glass_pane": "זגוגית אדומה",
  "block.minecraft.red_terracotta": "טרקוטה אדומה",
  "block.minecraft.red_tulip": "צבעוני אדום",
  "block.minecraft.red_wool": "צמר אדום",
  "block.minecraft.redstone_block": "בלוק רדסטון",
  "block.minecraft.redstone_lamp": "מנורת רדסטון",
  "block.minecraft.redstone_ore": "עפרת רדסטון",
  "block.minecraft.redstone_torch": "לפיד רדסטון",
  "block.minecraft.redstone_wall_torch": "לפיד רדסטון",
  "block.minecraft.redstone_wire": "כבל רדסטון",
  "block.minecraft.reinforced_deepslate": "לווחה מחוזקת",
  "block.minecraft.repeater": "משחזר רדסטון",
  "block.minecraft.repeating_command_block": "בלוק פקודה מחזורי",
  "block.minecraft.resin_block": "בלוק שרף",
  "block.minecraft.resin_brick_slab": "לבני שרף חצויות",
  "block.minecraft.resin_brick_stairs": "מדרגות לבני שרף",
  "block.minecraft.resin_brick_wall": "קיר לבני שרף",
  "block.minecraft.resin_bricks": "לבני שרף",
  "block.minecraft.resin_clump": "גוש שרף",
  "block.minecraft.respawn_anchor": "עוגן התחדשות",
  "block.minecraft.rooted_dirt": "עפר משורש",
  "block.minecraft.rose_bush": "שיח ורדים",
  "block.minecraft.sand": "חול",
  "block.minecraft.sandstone": "אבן חול",
  "block.minecraft.sandstone_slab": "אבן חול חצויה",
  "block.minecraft.sandstone_stairs": "מדרגות אבן חול",
  "block.minecraft.sandstone_wall": "קיר אבן חול",
  "block.minecraft.scaffolding": "פיגום",
  "block.minecraft.sculk": "סקאלק",
  "block.minecraft.sculk_catalyst": "זרז סקאלק",
  "block.minecraft.sculk_sensor": "חיישן סקאלק",
  "block.minecraft.sculk_shrieker": "צווחן סקאלק",
  "block.minecraft.sculk_vein": "וריד סקאלק",
  "block.minecraft.sea_lantern": "מנורת ים",
  "block.minecraft.sea_pickle": "מלפפון ים",
  "block.minecraft.seagrass": "עשב ים",
  "block.minecraft.set_spawn": "נקודת התחדשות נקבעה",
  "block.minecraft.short_dry_grass": "דשא יבש קצר",
  "block.minecraft.short_grass": "דשא קצר",
  "block.minecraft.shroomlight": "פטריית זוהר",
  "block.minecraft.shulker_box": "תיבת שולקר",
  "block.minecraft.skeleton_skull": "גולגולת שלד",
  "block.minecraft.skeleton_wall_skull": "גולגולת שלד על הקיר",
  "block.minecraft.slime_block": "בלוק רפש",
  "block.minecraft.small_amethyst_bud": "ניצן אחלמה קטן",
  "block.minecraft.small_dripleaf": "עלה טפטוף קטן",
  "block.minecraft.smithing_table": "שולחן נפחות",
  "block.minecraft.smoker": "מעשן",
  "block.minecraft.smooth_basalt": "בזלת חלקה",
  "block.minecraft.smooth_quartz": "בלוק קוורץ חלק",
  "block.minecraft.smooth_quartz_slab": "קוורץ חלק חצוי",
  "block.minecraft.smooth_quartz_stairs": "מדרגות קוורץ חלק",
  "block.minecraft.smooth_red_sandstone": "אבן חול אדומה חלקה",
  "block.minecraft.smooth_red_sandstone_slab": "אבן חול אדומה חלקה חצויה",
  "block.minecraft.smooth_red_sandstone_stairs": "מדרגות אבן חול אדומה חלקה",
  "block.minecraft.smooth_sandstone": "אבן חול חלקה",
  "block.minecraft.smooth_sandstone_slab": "אבן חול חלקה חצויה",
  "block.minecraft.smooth_sandstone_stairs": "מדרגות אבן חול חלקה",
  "block.minecraft.smooth_stone": "אבן חלקה",
  "block.minecraft.smooth_stone_slab": "אבן חלקה חצויה",
  "block.minecraft.sniffer_egg": "ביצת רחרחן",
  "block.minecraft.snow": "שלג",
  "block.minecraft.snow_block": "בלוק שלג",
  "block.minecraft.soul_campfire": "מדורת נשמות",
  "block.minecraft.soul_fire": "אש נשמה",
  "block.minecraft.soul_lantern": "מנורת נשמה",
  "block.minecraft.soul_sand": "חול נשמה",
  "block.minecraft.soul_soil": "עפר נשמה",
  "block.minecraft.soul_torch": "לפיד נשמה",
  "block.minecraft.soul_wall_torch": "לפיד קיר נשמה",
  "block.minecraft.spawn.not_valid": "אין לך מיטה או עוגן התחדשות טעון, או שהם היו חסומים",
  "block.minecraft.spawner": "מזמן מפלצות",
  "block.minecraft.spawner.desc1": "לחיצה עם ביצת זימון:",
  "block.minecraft.spawner.desc2": "קובע סוג יצור",
  "block.minecraft.sponge": "ספוג",
  "block.minecraft.spore_blossom": "נבג פורח",
  "block.minecraft.spruce_button": "כפתור מאשוחית",
  "block.minecraft.spruce_door": "דלת אשוחית",
  "block.minecraft.spruce_fence": "גדר אשוחית",
  "block.minecraft.spruce_fence_gate": "שער גדר אשוחית",
  "block.minecraft.spruce_hanging_sign": "שלט תלוי מאשוחית",
  "block.minecraft.spruce_leaves": "עלי אשוחית",
  "block.minecraft.spruce_log": "עץ אשוחית",
  "block.minecraft.spruce_planks": "קרשי עץ אשוחית",
  "block.minecraft.spruce_pressure_plate": "לוחית לחץ מאשוחית",
  "block.minecraft.spruce_sapling": "שתיל אשוחית",
  "block.minecraft.spruce_shelf": "מדף אשוחית",
  "block.minecraft.spruce_sign": "שלט אשוחית",
  "block.minecraft.spruce_slab": "קרש אשוחית חצוי",
  "block.minecraft.spruce_stairs": "מדרגות אשוחית",
  "block.minecraft.spruce_trapdoor": "דלת סתרים מאשוחית",
  "block.minecraft.spruce_wall_hanging_sign": "שלט קיר תלוי מאשוחית",
  "block.minecraft.spruce_wall_sign": "שלט קיר מאשוחית",
  "block.minecraft.spruce_wood": "עץ אשוחית",
  "block.minecraft.sticky_piston": "בוכנה דביקה",
  "block.minecraft.stone": "אבן",
  "block.minecraft.stone_brick_slab": "לבני אבן חצויות",
  "block.minecraft.stone_brick_stairs": "מדרגות לבני אבן",
  "block.minecraft.stone_brick_wall": "קיר לבני אבן",
  "block.minecraft.stone_bricks": "לבני אבן",
  "block.minecraft.stone_button": "כפתור מאבן",
  "block.minecraft.stone_pressure_plate": "לוחית לחץ מאבן",
  "block.minecraft.stone_slab": "אבן חצויה",
  "block.minecraft.stone_stairs": "מדרגות אבן",
  "block.minecraft.stonecutter": "חותך אבנים",
  "block.minecraft.stripped_acacia_log": "עץ שיטה משויף",
  "block.minecraft.stripped_acacia_wood": "עץ שיטה משויף",
  "block.minecraft.stripped_bamboo_block": "בלוק במבוק משויף",
  "block.minecraft.stripped_birch_log": "עץ שדר משויף",
  "block.minecraft.stripped_birch_wood": "עץ שדר משויף",
  "block.minecraft.stripped_cherry_log": "עץ דובדבן משויף",
  "block.minecraft.stripped_cherry_wood": "עץ דובדבן משויף",
  "block.minecraft.stripped_crimson_hyphae": "גדילי ארגמן משוייפים",
  "block.minecraft.stripped_crimson_stem": "גזע פטריית ארגמן משויף",
  "block.minecraft.stripped_dark_oak_log": "עץ אלון כהה משויף",
  "block.minecraft.stripped_dark_oak_wood": "עץ אלון כהה משויף",
  "block.minecraft.stripped_jungle_log": "עץ ג'ונגל משויף",
  "block.minecraft.stripped_jungle_wood": "עץ ג'ונגל משויף",
  "block.minecraft.stripped_mangrove_log": "עץ מנגרוב משויף",
  "block.minecraft.stripped_mangrove_wood": "גזע עץ מנגרוב משויף",
  "block.minecraft.stripped_oak_log": "עץ אלון משויף",
  "block.minecraft.stripped_oak_wood": "עץ אלון משויף",
  "block.minecraft.stripped_pale_oak_log": "עץ אלון חיוור משויף",
  "block.minecraft.stripped_pale_oak_wood": "עץ אלון חיוור משויף",
  "block.minecraft.stripped_spruce_log": "עץ אשוחית משויף",
  "block.minecraft.stripped_spruce_wood": "עץ אשוחית משויף",
  "block.minecraft.stripped_warped_hyphae": "גדילים מעוותים משוייפים",
  "block.minecraft.stripped_warped_stem": "גזע מעוות משויף",
  "block.minecraft.structure_block": "בלוק מבנה",
  "block.minecraft.structure_void": "חלל מבנה",
  "block.minecraft.sugar_cane": "קנה סוכר",
  "block.minecraft.sunflower": "חמנית",
  "block.minecraft.suspicious_gravel": "חצץ חשוד",
  "block.minecraft.suspicious_sand": "חול מסתורי",
  "block.minecraft.sweet_berry_bush": "שיח פירות יער מתוקים",
  "block.minecraft.tall_dry_grass": "דשא יבש גבוה",
  "block.minecraft.tall_grass": "דשא גבוה",
  "block.minecraft.tall_seagrass": "עשב ים גבוה",
  "block.minecraft.target": "מטרה",
  "block.minecraft.terracotta": "טרקוטה",
  "block.minecraft.test_block": "בלוק בדיקה",
  "block.minecraft.test_instance_block": "בלוק יחידת בדיקה",
  "block.minecraft.tinted_glass": "זכוכית אטומה",
  "block.minecraft.tnt": "חומר נפץ",
  "block.minecraft.tnt.disabled": "פיצוץ חומר נפץ כבוי",
  "block.minecraft.torch": "לפיד",
  "block.minecraft.torchflower": "פרח לפיד",
  "block.minecraft.torchflower_crop": "יבול פרח לפיד",
  "block.minecraft.trapped_chest": "תיבה ממולכדת",
  "block.minecraft.trial_spawner": "מזמן אתגרים",
  "block.minecraft.tripwire": "חוט מעידה",
  "block.minecraft.tripwire_hook": "קרס חוט מעידה",
  "block.minecraft.tube_coral": "צמח אלמוג צינורי",
  "block.minecraft.tube_coral_block": "אלמוג צינורי",
  "block.minecraft.tube_coral_fan": "ענף אלמוג צינורי",
  "block.minecraft.tube_coral_wall_fan": "ענף קיר אלמוג צינורי",
  "block.minecraft.tuff": "טוף",
  "block.minecraft.tuff_brick_slab": "לבנת טוף חצויה",
  "block.minecraft.tuff_brick_stairs": "מדרגות לבני טוף",
  "block.minecraft.tuff_brick_wall": "קיר לבני טוף",
  "block.minecraft.tuff_bricks": "לבני טוף",
  "block.minecraft.tuff_slab": "טוף חצוי",
  "block.minecraft.tuff_stairs": "מדרגות טוף",
  "block.minecraft.tuff_wall": "קיר טוף",
  "block.minecraft.turtle_egg": "ביצת צב",
  "block.minecraft.twisting_vines": "גפנים מתפתלות",
  "block.minecraft.twisting_vines_plant": "צמח גפנים מתפתלות",
  "block.minecraft.vault": "כספת",
  "block.minecraft.verdant_froglight": "מנורת צפרדע ירוקה",
  "block.minecraft.vine": "גפנים",
  "block.minecraft.void_air": "אוויר הריק",
  "block.minecraft.wall_torch": "לפיד קיר",
  "block.minecraft.warped_button": "כפתור מעוות",
  "block.minecraft.warped_door": "דלת מעוותת",
  "block.minecraft.warped_fence": "גדר מעוותת",
  "block.minecraft.warped_fence_gate": "שער גדר מעוותת",
  "block.minecraft.warped_fungus": "פטרייה מעוותת",
  "block.minecraft.warped_hanging_sign": "שלט תלוי מעוות",
  "block.minecraft.warped_hyphae": "גדילים מעוותים",
  "block.minecraft.warped_nylium": "נייליום מעוות",
  "block.minecraft.warped_planks": "קרשים מעוותים",
  "block.minecraft.warped_pressure_plate": "לוחית לחץ מעוותת",
  "block.minecraft.warped_roots": "שורשים מעוותים",
  "block.minecraft.warped_shelf": "מדף מעוות",
  "block.minecraft.warped_sign": "שלט מעוות",
  "block.minecraft.warped_slab": "קרש מעוות חצוי",
  "block.minecraft.warped_stairs": "מדרגות מעוותות",
  "block.minecraft.warped_stem": "גזע מעוות",
  "block.minecraft.warped_trapdoor": "דלת סתרים מעוותת",
  "block.minecraft.warped_wall_hanging_sign": "שלט קיר תלוי מעוות",
  "block.minecraft.warped_wall_sign": "שלט קיר מעץ מעוות",
  "block.minecraft.warped_wart_block": "בלוק שיבולת נד'ר מעוות",
  "block.minecraft.water": "מים",
  "block.minecraft.water_cauldron": "קדרת מים",
  "block.minecraft.waxed_chiseled_copper": "נחושת מפוסלת מצופת שעווה",
  "block.minecraft.waxed_copper_bars": "סורגי נחושת מצופים שעווה",
  "block.minecraft.waxed_copper_block": "בלוק נחושת מצופה שעווה",
  "block.minecraft.waxed_copper_bulb": "נורת נחושת מצופת שעווה",
  "block.minecraft.waxed_copper_chain": "שרשרת נחושת מצופת שעווה",
  "block.minecraft.waxed_copper_chest": "תיבה נחושת מצופת שעווה",
  "block.minecraft.waxed_copper_door": "דלת נחושת מצופת שעווה",
  "block.minecraft.waxed_copper_golem_statue": "פסל גולם נחושת מצופה שעווה",
  "block.minecraft.waxed_copper_grate": "מגררת נחושת מצופת שעווה",
  "block.minecraft.waxed_copper_lantern": "עששית נחושת מצופת שעווה",
  "block.minecraft.waxed_copper_trapdoor": "דלת סתרים מנחושת מצופת שעווה",
  "block.minecraft.waxed_cut_copper": "לבני נחושת מצופות שעווה",
  "block.minecraft.waxed_cut_copper_slab": "לבנת נחושת מצופת שעווה חצויה",
  "block.minecraft.waxed_cut_copper_stairs": "מדרגות לבני נחושת מצופות שעווה",
  "block.minecraft.waxed_exposed_chiseled_copper": "נחושת חשופה מפוסלת מצופת שעווה",
  "block.minecraft.waxed_exposed_copper": "נחושת חשופה מצופת שעווה",
  "block.minecraft.waxed_exposed_copper_bars": "סורגי נחושת חשופים מצופים שעווה",
  "block.minecraft.waxed_exposed_copper_bulb": "נורת נחושת חשופה מצופת שעווה",
  "block.minecraft.waxed_exposed_copper_chain": "שרשרת נחושת חשופה מצופת שעווה",
  "block.minecraft.waxed_exposed_copper_chest": "תיבה נחושת חשופה מצופת שעווה",
  "block.minecraft.waxed_exposed_copper_door": "דלת נחושת חשופה מצופת שעווה",
  "block.minecraft.waxed_exposed_copper_golem_statue": "פסל גולם נחושת חשופה מצופה שעווה",
  "block.minecraft.waxed_exposed_copper_grate": "מגררת נחושת חשופה מצופת שעווה",
  "block.minecraft.waxed_exposed_copper_lantern": "עששית נחושת חשופה מצופת שעווה",
  "block.minecraft.waxed_exposed_copper_trapdoor": "דלת סתרים מנחושת חשופה מצופת שעווה",
  "block.minecraft.waxed_exposed_cut_copper": "לבני נחושת חשופות מצופות שעווה",
  "block.minecraft.waxed_exposed_cut_copper_slab": "לבנת נחושת חשופה מצופת שעווה חצויה",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "מדרגות לבני נחושת חשופות מצופות שעווה",
  "block.minecraft.waxed_exposed_lightning_rod": "כליא ברק חשוף מצופה שעווה",
  "block.minecraft.waxed_lightning_rod": "כליא ברק מצופה שעווה",
  "block.minecraft.waxed_oxidized_chiseled_copper": "נחושת מחומצנת מפוסלת מצופת שעווה",
  "block.minecraft.waxed_oxidized_copper": "נחושת מחומצנת מצופת שעווה",
  "block.minecraft.waxed_oxidized_copper_bars": "סורגי נחושת מחומצנים מצופי שעווה",
  "block.minecraft.waxed_oxidized_copper_bulb": "נורת נחושת מחומצנת מצופת שעווה",
  "block.minecraft.waxed_oxidized_copper_chain": "שרשרת נחושת מחומצנת מצופת שעווה",
  "block.minecraft.waxed_oxidized_copper_chest": "תיבה נחושת מחומצנת מצופת שעווה",
  "block.minecraft.waxed_oxidized_copper_door": "דלת נחושת מחומצנת מצופת שעווה",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "פסל גולם נחושת מחומצנת מצופה שעווה",
  "block.minecraft.waxed_oxidized_copper_grate": "מגררת נחושת מחומצנת מצופת שעווה",
  "block.minecraft.waxed_oxidized_copper_lantern": "עששית נחושת מחומצנת מצופת שעווה",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "דלת סתרים מנחושת מחומצנת מצופת שעווה",
  "block.minecraft.waxed_oxidized_cut_copper": "לבני נחושת מחומצנות מצופות שעווה",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "לבנת נחושת מחומצנת מצופת שעווה חצויה",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "מדרגות לבני נחושת מחומצנות מצופות שעווה",
  "block.minecraft.waxed_oxidized_lightning_rod": "כליא ברק מחומצן מצופה שעווה",
  "block.minecraft.waxed_weathered_chiseled_copper": "נחושת מפוסלת בלויה מצופת שעווה",
  "block.minecraft.waxed_weathered_copper": "נחושת בלויה מצופת שעווה",
  "block.minecraft.waxed_weathered_copper_bars": "סורגי נחושת בלויים מצופים שעווה",
  "block.minecraft.waxed_weathered_copper_bulb": "נורת נחושת בלויה מצופת שעווה",
  "block.minecraft.waxed_weathered_copper_chain": "שרשרת נחושת בלויה מצופת שעווה",
  "block.minecraft.waxed_weathered_copper_chest": "תיבת נחושת בלויה מצופת שעווה",
  "block.minecraft.waxed_weathered_copper_door": "דלת נחושת בלויה מצופת שעווה",
  "block.minecraft.waxed_weathered_copper_golem_statue": "פסל גולם נחושת בלויה מצופה שעווה",
  "block.minecraft.waxed_weathered_copper_grate": "מגררת נחושת בלויה מצופת שעווה",
  "block.minecraft.waxed_weathered_copper_lantern": "עששית נחושת בלויה מצופת שעווה",
  "block.minecraft.waxed_weathered_copper_trapdoor": "דלת סתרים מנחושת בלויה מצופת שעווה",
  "block.minecraft.waxed_weathered_cut_copper": "לבני נחושת בלויות מצופות שעווה",
  "block.minecraft.waxed_weathered_cut_copper_slab": "לבנת נחושת בלויה מצופת שעווה חצויה",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "מדרגות לבני נחושת בלויות מצופות שעווה",
  "block.minecraft.waxed_weathered_lightning_rod": "כליא ברק בלוי מצופה שעווה",
  "block.minecraft.weathered_chiseled_copper": "נחושת מפוסלת בלויה",
  "block.minecraft.weathered_copper": "נחושת בלויה",
  "block.minecraft.weathered_copper_bars": "סורגי נחושת בלויים",
  "block.minecraft.weathered_copper_bulb": "נורת נחושת בלויה",
  "block.minecraft.weathered_copper_chain": "שרשרת נחושת בלויה",
  "block.minecraft.weathered_copper_chest": "תיבה נחושת בלויה",
  "block.minecraft.weathered_copper_door": "דלת נחושת בלויה",
  "block.minecraft.weathered_copper_golem_statue": "פסל גולם נחושת בלויה",
  "block.minecraft.weathered_copper_grate": "מגררת נחושת בלויה",
  "block.minecraft.weathered_copper_lantern": "עששית נחושת בלויה",
  "block.minecraft.weathered_copper_trapdoor": "דלת סתרים מנחושת בלויה",
  "block.minecraft.weathered_cut_copper": "לבני נחושת בלויות",
  "block.minecraft.weathered_cut_copper_slab": "לבנת נחושת בלויה חצויה",
  "block.minecraft.weathered_cut_copper_stairs": "מדרגות לבני נחושת בלויות",
  "block.minecraft.weathered_lightning_rod": "כליא ברק בלוי",
  "block.minecraft.weeping_vines": "גפני בכי",
  "block.minecraft.weeping_vines_plant": "צמח גפני בכי",
  "block.minecraft.wet_sponge": "ספוג רטוב",
  "block.minecraft.wheat": "חיטה",
  "block.minecraft.white_banner": "באנר לבן",
  "block.minecraft.white_bed": "מיטה לבנה",
  "block.minecraft.white_candle": "נר לבן",
  "block.minecraft.white_candle_cake": "עוגה עם נר לבן",
  "block.minecraft.white_carpet": "שטיח לבן",
  "block.minecraft.white_concrete": "בטון לבן",
  "block.minecraft.white_concrete_powder": "אבקת בטון לבנה",
  "block.minecraft.white_glazed_terracotta": "טרקוטה מזוגגת לבנה",
  "block.minecraft.white_shulker_box": "תיבת שולקר לבנה",
  "block.minecraft.white_stained_glass": "זכוכית לבנה",
  "block.minecraft.white_stained_glass_pane": "זגוגית לבנה",
  "block.minecraft.white_terracotta": "טרקוטה לבנה",
  "block.minecraft.white_tulip": "צבעוני לבן",
  "block.minecraft.white_wool": "צמר לבן",
  "block.minecraft.wildflowers": "פרחי בר",
  "block.minecraft.wither_rose": "ורד וויד'ר",
  "block.minecraft.wither_skeleton_skull": "גולגולת שלד וויד'ר",
  "block.minecraft.wither_skeleton_wall_skull": "גולגולת שלד וויד'ר על הקיר",
  "block.minecraft.yellow_banner": "באנר צהוב",
  "block.minecraft.yellow_bed": "מיטה צהובה",
  "block.minecraft.yellow_candle": "נר צהוב",
  "block.minecraft.yellow_candle_cake": "עוגה עם נר צהוב",
  "block.minecraft.yellow_carpet": "שטיח צהוב",
  "block.minecraft.yellow_concrete": "בטון צהוב",
  "block.minecraft.yellow_concrete_powder": "אבקת בטון צהובה",
  "block.minecraft.yellow_glazed_terracotta": "טרקוטה מזוגגת צהובה",
  "block.minecraft.yellow_shulker_box": "תיבת שולקר צהובה",
  "block.minecraft.yellow_stained_glass": "זכוכית צהובה",
  "block.minecraft.yellow_stained_glass_pane": "זגוגית צהובה",
  "block.minecraft.yellow_terracotta": "טרקוטה צהובה",
  "block.minecraft.yellow_wool": "צמר צהוב",
  "block.minecraft.zombie_head": "ראש זומבי",
  "block.minecraft.zombie_wall_head": "ראש זומבי על הקיר",
  "item.minecraft.acacia_boat": "סירת שיטה",
  "item.minecraft.acacia_chest_boat": "סירת שיטה עם תיבה",
  "item.minecraft.allay_spawn_egg": "ביצת זימון אלאיי",
  "item.minecraft.amethyst_shard": "רסיס אחלמה",
  "item.minecraft.angler_pottery_shard": "שבר חרס דיג",
  "item.minecraft.angler_pottery_sherd": "שבר חרס דייג",
  "item.minecraft.apple": "תפוח",
  "item.minecraft.archer_pottery_shard": "שבר חרס קשת",
  "item.minecraft.archer_pottery_sherd": "שבר חרס קשת",
  "item.minecraft.armadillo_scute": "חתיכת שריון ארמדיל",
  "item.minecraft.armadillo_spawn_egg": "ביצת זימון ארמדיל",
  "item.minecraft.armor_stand": "מעמד שריון",
  "item.minecraft.arms_up_pottery_shard": "שבר חרס ידיים למעלה",
  "item.minecraft.arms_up_pottery_sherd": "שבר חרס ידיים למעלה",
  "item.minecraft.arrow": "חץ",
  "item.minecraft.axolotl_bucket": "דלי אקסולוטל",
  "item.minecraft.axolotl_spawn_egg": "ביצת זימון אקסולוטל",
  "item.minecraft.baked_potato": "תפוח אדמה אפוי",
  "item.minecraft.bamboo_chest_raft": "רפסודת במבוק עם תיבה",
  "item.minecraft.bamboo_raft": "רפסודת במבוק",
  "item.minecraft.bat_spawn_egg": "ביצת זימון עטלף",
  "item.minecraft.bee_spawn_egg": "ביצת זימון דבורה",
  "item.minecraft.beef": "בקר נא",
  "item.minecraft.beetroot": "סלק אדום",
  "item.minecraft.beetroot_seeds": "זרעי סלק",
  "item.minecraft.beetroot_soup": "מרק סלק אדום",
  "item.minecraft.birch_boat": "סירת שדר",
  "item.minecraft.birch_chest_boat": "סירת שדר עם תיבה",
  "item.minecraft.black_bundle": "שק שחור",
  "item.minecraft.black_dye": "צבע שחור",
  "item.minecraft.black_harness": "רתמה שחורה",
  "item.minecraft.blade_pottery_shard": "שבר חרס להב",
  "item.minecraft.blade_pottery_sherd": "שבר חרס להב",
  "item.minecraft.blaze_powder": "אבקת להבון",
  "item.minecraft.blaze_rod": "מוט להבון",
  "item.minecraft.blaze_spawn_egg": "ביצת זימון להבון",
  "item.minecraft.blue_bundle": "שק כחול",
  "item.minecraft.blue_dye": "צבע כחול",
  "item.minecraft.blue_egg": "ביצה כחולה",
  "item.minecraft.blue_harness": "רתמה כחולה",
  "item.minecraft.bogged_spawn_egg": "ביצת זימון שקוע",
  "item.minecraft.bolt_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "עיטור שריון ברק",
  "item.minecraft.bone": "עצם",
  "item.minecraft.bone_meal": "דשן",
  "item.minecraft.book": "ספר",
  "item.minecraft.bordure_indented_banner_pattern": "תבנית דגל של גבול",
  "item.minecraft.bow": "קשת",
  "item.minecraft.bowl": "קערה",
  "item.minecraft.bread": "לחם",
  "item.minecraft.breeze_rod": "מוט בריז",
  "item.minecraft.breeze_spawn_egg": "ביצת זימון בריז",
  "item.minecraft.brewer_pottery_shard": "שבר חרס רוקח",
  "item.minecraft.brewer_pottery_sherd": "שבר חרס רוקח",
  "item.minecraft.brewing_stand": "עמדת רקיחה",
  "item.minecraft.brick": "לבנה",
  "item.minecraft.brown_bundle": "שק חום",
  "item.minecraft.brown_dye": "צבע חום",
  "item.minecraft.brown_egg": "ביצה חומה",
  "item.minecraft.brown_harness": "רתמה חומה",
  "item.minecraft.brush": "מברשת",
  "item.minecraft.bucket": "דלי",
  "item.minecraft.bundle": "שק",
  "item.minecraft.bundle.empty": "ריק",
  "item.minecraft.bundle.empty.description": "יכול להחזיק ערימה מעורבת של פריטים",
  "item.minecraft.bundle.full": "מלא",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "שבר חרס בוער",
  "item.minecraft.burn_pottery_sherd": "שבר חרס בעירה",
  "item.minecraft.camel_husk_spawn_egg": "ביצת זימון האסק גמל",
  "item.minecraft.camel_spawn_egg": "ביצת זימון גמל",
  "item.minecraft.carrot": "גזר",
  "item.minecraft.carrot_on_a_stick": "גזר על מקל",
  "item.minecraft.cat_spawn_egg": "ביצת זימון חתול",
  "item.minecraft.cauldron": "קדרה",
  "item.minecraft.cave_spider_spawn_egg": "ביצת זימון עכביש מערות",
  "item.minecraft.chainmail_boots": "מגפי שרשראות ברזל",
  "item.minecraft.chainmail_chestplate": "שריון שרשראות ברזל",
  "item.minecraft.chainmail_helmet": "קסדת שרשראות ברזל",
  "item.minecraft.chainmail_leggings": "מכנסי שרשראות ברזל",
  "item.minecraft.charcoal": "פחם עץ",
  "item.minecraft.cherry_boat": "סירת עץ דובדבן",
  "item.minecraft.cherry_chest_boat": "סירת עץ דובדבן עם תיבה",
  "item.minecraft.chest_minecart": "קרונית עם תיבה",
  "item.minecraft.chicken": "עוף נא",
  "item.minecraft.chicken_spawn_egg": "ביצת זימון תרנגול",
  "item.minecraft.chorus_fruit": "פרי קורוס",
  "item.minecraft.clay_ball": "חימר",
  "item.minecraft.clock": "שעון",
  "item.minecraft.coal": "פחם",
  "item.minecraft.coast_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.coast_armor_trim_smithing_template.new": "עיטור שריון חוף",
  "item.minecraft.cocoa_beans": "פולי קקאו",
  "item.minecraft.cod": "בקלה נא",
  "item.minecraft.cod_bucket": "דלי בקלה",
  "item.minecraft.cod_spawn_egg": "ביצת זימון בקלה",
  "item.minecraft.command_block_minecart": "קרונית עם בלוק פקודה",
  "item.minecraft.compass": "מצפן",
  "item.minecraft.cooked_beef": "סטייק",
  "item.minecraft.cooked_chicken": "עוף מבושל",
  "item.minecraft.cooked_cod": "בקלה אפוי",
  "item.minecraft.cooked_mutton": "בשר כבש מבושל",
  "item.minecraft.cooked_porkchop": "צלע חזיר מבושלת",
  "item.minecraft.cooked_rabbit": "ארנב מבושל",
  "item.minecraft.cooked_salmon": "סלמון מבושל",
  "item.minecraft.cookie": "עוגייה",
  "item.minecraft.copper_axe": "גרזן נחושת",
  "item.minecraft.copper_boots": "מגפי נחושת",
  "item.minecraft.copper_chestplate": "שריון נחושת",
  "item.minecraft.copper_golem_spawn_egg": "ביצת זימון גולם נחושת",
  "item.minecraft.copper_helmet": "קסדת נחושת",
  "item.minecraft.copper_hoe": "מעדר נחושת",
  "item.minecraft.copper_horse_armor": "שריון סוס מנחושת",
  "item.minecraft.copper_ingot": "מטיל נחושת",
  "item.minecraft.copper_leggings": "מכנסי נחושת",
  "item.minecraft.copper_nautilus_armor": "שריון שייטן מנחושת",
  "item.minecraft.copper_nugget": "גוש נחושת",
  "item.minecraft.copper_pickaxe": "מכוש נחושת",
  "item.minecraft.copper_shovel": "את נחושת",
  "item.minecraft.copper_spear": "חנית נחושת",
  "item.minecraft.copper_sword": "חרב נחושת",
  "item.minecraft.cow_spawn_egg": "ביצת זימון פרה",
  "item.minecraft.creaking_spawn_egg": "ביצת זימון חריקה",
  "item.minecraft.creeper_banner_pattern": "תבנית דגל",
  "item.minecraft.creeper_banner_pattern.desc": "מטען קריפר",
  "item.minecraft.creeper_banner_pattern.new": "תבנית דגל של מטען קריפר",
  "item.minecraft.creeper_spawn_egg": "ביצת זימון קריפר",
  "item.minecraft.crossbow": "קשת מוצלבת",
  "item.minecraft.crossbow.projectile": "קליע:",
  "item.minecraft.crossbow.projectile.multiple": "קליע: %s x %s",
  "item.minecraft.crossbow.projectile.single": "קליע: %s",
  "item.minecraft.cyan_bundle": "שק ציאן",
  "item.minecraft.cyan_dye": "צבע ציאן",
  "item.minecraft.cyan_harness": "רתמה ציאן",
  "item.minecraft.danger_pottery_shard": "שבר חרס סכנה",
  "item.minecraft.danger_pottery_sherd": "שבר חרס סכנה",
  "item.minecraft.dark_oak_boat": "סירת אלון כהה",
  "item.minecraft.dark_oak_chest_boat": "סירת אלון כהה עם תיבה",
  "item.minecraft.debug_stick": "מקל המצבים",
  "item.minecraft.debug_stick.empty": "ל %s אין מאפיינים",
  "item.minecraft.debug_stick.select": "נבחר \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ל %s",
  "item.minecraft.diamond": "יהלום",
  "item.minecraft.diamond_axe": "גרזן יהלום",
  "item.minecraft.diamond_boots": "מגפי יהלום",
  "item.minecraft.diamond_chestplate": "שריון יהלום",
  "item.minecraft.diamond_helmet": "קסדת יהלום",
  "item.minecraft.diamond_hoe": "מעדר יהלום",
  "item.minecraft.diamond_horse_armor": "שריון סוס מיהלום",
  "item.minecraft.diamond_leggings": "מכנסי יהלום",
  "item.minecraft.diamond_nautilus_armor": "שריון שייטן מיהלום",
  "item.minecraft.diamond_pickaxe": "מכוש יהלום",
  "item.minecraft.diamond_shovel": "את יהלום",
  "item.minecraft.diamond_spear": "חנית יהלום",
  "item.minecraft.diamond_sword": "חרב יהלום",
  "item.minecraft.disc_fragment_5": "שבר דיסק",
  "item.minecraft.disc_fragment_5.desc": "דיסק מוזיקה - 5",
  "item.minecraft.dolphin_spawn_egg": "ביצת זימון דולפין",
  "item.minecraft.donkey_spawn_egg": "ביצת זימון חמור",
  "item.minecraft.dragon_breath": "נשימת דרקון",
  "item.minecraft.dried_kelp": "אצה מיובשת",
  "item.minecraft.drowned_spawn_egg": "ביצת זימון טבוע",
  "item.minecraft.dune_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.dune_armor_trim_smithing_template.new": "עיטור שריון דיונה",
  "item.minecraft.echo_shard": "רסיס הד",
  "item.minecraft.egg": "ביצה",
  "item.minecraft.elder_guardian_spawn_egg": "ביצת זימון שומר עתיק",
  "item.minecraft.elytra": "אליטרה",
  "item.minecraft.emerald": "ברקת",
  "item.minecraft.enchanted_book": "ספר מכושף",
  "item.minecraft.enchanted_golden_apple": "תפוח מוזהב מכושף",
  "item.minecraft.end_crystal": "קריסטל אנד",
  "item.minecraft.ender_dragon_spawn_egg": "ביצת זימון דרקון אנדר",
  "item.minecraft.ender_eye": "עין אנדר",
  "item.minecraft.ender_pearl": "פנינת אנדר",
  "item.minecraft.enderman_spawn_egg": "ביצת זימון אנדרמן",
  "item.minecraft.endermite_spawn_egg": "ביצת זימון אנדרמייט",
  "item.minecraft.evoker_spawn_egg": "ביצת זימון מעורר",
  "item.minecraft.experience_bottle": "בקבוק כישופים",
  "item.minecraft.explorer_pottery_shard": "שבר חרס חוקר",
  "item.minecraft.explorer_pottery_sherd": "שבר חרס חוקר",
  "item.minecraft.eye_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.eye_armor_trim_smithing_template.new": "עיטור שריון עין",
  "item.minecraft.feather": "נוצה",
  "item.minecraft.fermented_spider_eye": "עין עכביש תסוסה",
  "item.minecraft.field_masoned_banner_pattern": "תבנית דגל של לבנים",
  "item.minecraft.filled_map": "מפה",
  "item.minecraft.fire_charge": "כדור אש",
  "item.minecraft.firework_rocket": "טיל זיקוק",
  "item.minecraft.firework_rocket.flight": "משך הטיסה:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "כוכב זיקוק",
  "item.minecraft.firework_star.black": "שחור",
  "item.minecraft.firework_star.blue": "כחול",
  "item.minecraft.firework_star.brown": "חום",
  "item.minecraft.firework_star.custom_color": "מותאם אישית",
  "item.minecraft.firework_star.cyan": "ציאן",
  "item.minecraft.firework_star.fade_to": "עמעום",
  "item.minecraft.firework_star.flicker": "ניצנוץ",
  "item.minecraft.firework_star.gray": "אפור",
  "item.minecraft.firework_star.green": "ירוק",
  "item.minecraft.firework_star.light_blue": "תכלת",
  "item.minecraft.firework_star.light_gray": "אפור בהיר",
  "item.minecraft.firework_star.lime": "ליים",
  "item.minecraft.firework_star.magenta": "מג'נטה",
  "item.minecraft.firework_star.orange": "כתום",
  "item.minecraft.firework_star.pink": "ורוד",
  "item.minecraft.firework_star.purple": "סגול",
  "item.minecraft.firework_star.red": "אדום",
  "item.minecraft.firework_star.shape": "צורה לא ידועה",
  "item.minecraft.firework_star.shape.burst": "התפרצות",
  "item.minecraft.firework_star.shape.creeper": "צורת קריפר",
  "item.minecraft.firework_star.shape.large_ball": "כדור גדול",
  "item.minecraft.firework_star.shape.small_ball": "כדור קטן",
  "item.minecraft.firework_star.shape.star": "צורת כוכב",
  "item.minecraft.firework_star.trail": "שובל",
  "item.minecraft.firework_star.white": "לבן",
  "item.minecraft.firework_star.yellow": "צהוב",
  "item.minecraft.fishing_rod": "חכת דיג",
  "item.minecraft.flint": "צור",
  "item.minecraft.flint_and_steel": "צור ופלדה",
  "item.minecraft.flow_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.flow_armor_trim_smithing_template.new": "עיטור שריון זרימה",
  "item.minecraft.flow_banner_pattern": "תבנית דגל",
  "item.minecraft.flow_banner_pattern.desc": "זרימה",
  "item.minecraft.flow_banner_pattern.new": "תבנית דגל של זרימה",
  "item.minecraft.flow_pottery_sherd": "שבר חרס זרימה",
  "item.minecraft.flower_banner_pattern": "תבנית דגל",
  "item.minecraft.flower_banner_pattern.desc": "מטען פרח",
  "item.minecraft.flower_banner_pattern.new": "תבנית דגל של מטען פרח",
  "item.minecraft.flower_pot": "עציץ",
  "item.minecraft.fox_spawn_egg": "ביצת זימון שועל",
  "item.minecraft.friend_pottery_shard": "שבר חרס ידיד",
  "item.minecraft.friend_pottery_sherd": "שבר חרס ידיד",
  "item.minecraft.frog_spawn_egg": "ביצת זימון צפרדע",
  "item.minecraft.furnace_minecart": "קרונית עם תנור",
  "item.minecraft.ghast_spawn_egg": "ביצת זימון גאסט",
  "item.minecraft.ghast_tear": "דמעת גאסט",
  "item.minecraft.glass_bottle": "בקבוק זכוכית",
  "item.minecraft.glistering_melon_slice": "פרוסת אבטיח מנצנץ",
  "item.minecraft.globe_banner_pattern": "תבנית דגל",
  "item.minecraft.globe_banner_pattern.desc": "גלובוס",
  "item.minecraft.globe_banner_pattern.new": "תבנית דגל של עולם",
  "item.minecraft.glow_berries": "פירות יער זוהרים",
  "item.minecraft.glow_ink_sac": "שק דיו זוהר",
  "item.minecraft.glow_item_frame": "מסגרת פריט זוהרת",
  "item.minecraft.glow_squid_spawn_egg": "ביצת זימון דיונון זוהר",
  "item.minecraft.glowstone_dust": "אבקת אבן זוהרת",
  "item.minecraft.goat_horn": "קרן עז",
  "item.minecraft.goat_spawn_egg": "ביצת זימון עז",
  "item.minecraft.gold_ingot": "מטיל זהב",
  "item.minecraft.gold_nugget": "גוש זהב",
  "item.minecraft.golden_apple": "תפוח מוזהב",
  "item.minecraft.golden_axe": "גרזן זהב",
  "item.minecraft.golden_boots": "מגפי זהב",
  "item.minecraft.golden_carrot": "גזר מוזהב",
  "item.minecraft.golden_chestplate": "שריון זהב",
  "item.minecraft.golden_helmet": "קסדת זהב",
  "item.minecraft.golden_hoe": "מעדר זהב",
  "item.minecraft.golden_horse_armor": "שריון סוס מזהב",
  "item.minecraft.golden_leggings": "מכנסי זהב",
  "item.minecraft.golden_nautilus_armor": "שריון שייטן מזהב",
  "item.minecraft.golden_pickaxe": "מכוש זהב",
  "item.minecraft.golden_shovel": "את זהב",
  "item.minecraft.golden_spear": "חנית זהב",
  "item.minecraft.golden_sword": "חרב זהב",
  "item.minecraft.gray_bundle": "שק אפור",
  "item.minecraft.gray_dye": "צבע אפור",
  "item.minecraft.gray_harness": "רתמה אפורה",
  "item.minecraft.green_bundle": "שק ירוק",
  "item.minecraft.green_dye": "צבע ירוק",
  "item.minecraft.green_harness": "רתמה ירוקה",
  "item.minecraft.guardian_spawn_egg": "ביצת זימון שומר",
  "item.minecraft.gunpowder": "אבק שריפה",
  "item.minecraft.guster_banner_pattern": "תבנית דגל",
  "item.minecraft.guster_banner_pattern.desc": "סופה",
  "item.minecraft.guster_banner_pattern.new": "תבנית דגל של סופה",
  "item.minecraft.guster_pottery_sherd": "שבר חרס סופה",
  "item.minecraft.happy_ghast_spawn_egg": "ביצת זימון גאסט שמח",
  "item.minecraft.harness": "רתמה",
  "item.minecraft.heart_of_the_sea": "לב הים",
  "item.minecraft.heart_pottery_shard": "שבר חרס לב",
  "item.minecraft.heart_pottery_sherd": "שבר חרס לב",
  "item.minecraft.heartbreak_pottery_shard": "שבר חרס שברון לב",
  "item.minecraft.heartbreak_pottery_sherd": "שבר חרס לב שבור",
  "item.minecraft.hoglin_spawn_egg": "ביצת זימון הוגלין",
  "item.minecraft.honey_bottle": "בקבוק דבש",
  "item.minecraft.honeycomb": "חלת דבש",
  "item.minecraft.hopper_minecart": "קרונית עם משפך",
  "item.minecraft.horse_spawn_egg": "ביצת זימון סוס",
  "item.minecraft.host_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.host_armor_trim_smithing_template.new": "עיטור שריון מנחה",
  "item.minecraft.howl_pottery_shard": "שבר חרס יללה",
  "item.minecraft.howl_pottery_sherd": "שבר חרס יללה",
  "item.minecraft.husk_spawn_egg": "ביצת זימון האסק",
  "item.minecraft.ink_sac": "שק דיו",
  "item.minecraft.iron_axe": "גרזן ברזל",
  "item.minecraft.iron_boots": "מגפי ברזל",
  "item.minecraft.iron_chestplate": "שריון ברזל",
  "item.minecraft.iron_golem_spawn_egg": "ביצת זימון גולם ברזל",
  "item.minecraft.iron_helmet": "קסדת ברזל",
  "item.minecraft.iron_hoe": "מעדר ברזל",
  "item.minecraft.iron_horse_armor": "שריון סוס מברזל",
  "item.minecraft.iron_ingot": "מטיל ברזל",
  "item.minecraft.iron_leggings": "מכנסי ברזל",
  "item.minecraft.iron_nautilus_armor": "שריון שייטן מברזל",
  "item.minecraft.iron_nugget": "גוש ברזל",
  "item.minecraft.iron_pickaxe": "מכוש ברזל",
  "item.minecraft.iron_shovel": "את ברזל",
  "item.minecraft.iron_spear": "חנית ברזל",
  "item.minecraft.iron_sword": "חרב ברזל",
  "item.minecraft.item_frame": "מסגרת פריט",
  "item.minecraft.jungle_boat": "סירת עץ ג'ונגל",
  "item.minecraft.jungle_chest_boat": "סירת עץ ג'ונגל עם תיבה",
  "item.minecraft.knowledge_book": "ספר הידע",
  "item.minecraft.lapis_lazuli": "לאפיס לאזולי",
  "item.minecraft.lava_bucket": "דלי לבה",
  "item.minecraft.lead": "חבל",
  "item.minecraft.leather": "עור",
  "item.minecraft.leather_boots": "מגפי עור",
  "item.minecraft.leather_chestplate": "טוניקת עור",
  "item.minecraft.leather_helmet": "כובע עור",
  "item.minecraft.leather_horse_armor": "שריון סוס מעור",
  "item.minecraft.leather_leggings": "מכנסי עור",
  "item.minecraft.light_blue_bundle": "שק תכלת",
  "item.minecraft.light_blue_dye": "צבע תכלת",
  "item.minecraft.light_blue_harness": "רתמה תכלת",
  "item.minecraft.light_gray_bundle": "שק אפור בהיר",
  "item.minecraft.light_gray_dye": "צבע אפור בהיר",
  "item.minecraft.light_gray_harness": "רתמה אפורה בהירה",
  "item.minecraft.lime_bundle": "שק ליים",
  "item.minecraft.lime_dye": "צבע ליים",
  "item.minecraft.lime_harness": "רתמה ליים",
  "item.minecraft.lingering_potion": "שיקוי שהייה",
  "item.minecraft.lingering_potion.effect.awkward": "שיקוי השתהות מביך",
  "item.minecraft.lingering_potion.effect.empty": "שיקוי השתהות בלתי ניתן להכנה",
  "item.minecraft.lingering_potion.effect.fire_resistance": "שיקוי השתהות של חסינות לאש",
  "item.minecraft.lingering_potion.effect.harming": "שיקוי השתהות של פגיעה",
  "item.minecraft.lingering_potion.effect.healing": "שיקוי השתהות של ריפוי",
  "item.minecraft.lingering_potion.effect.infested": "שיקוי השתהות של שריצה",
  "item.minecraft.lingering_potion.effect.invisibility": "שיקוי השתהות של היעלמות",
  "item.minecraft.lingering_potion.effect.leaping": "שיקוי השתהות של זינוק",
  "item.minecraft.lingering_potion.effect.levitation": "שיקוי השתהות של ריחוף",
  "item.minecraft.lingering_potion.effect.luck": "שיקוי השתהות של מזל",
  "item.minecraft.lingering_potion.effect.mundane": "שיקוי השתהות רגיל",
  "item.minecraft.lingering_potion.effect.night_vision": "שיקוי השתהות של ראיית לילה",
  "item.minecraft.lingering_potion.effect.oozing": "שיקוי השתהות של דליפה",
  "item.minecraft.lingering_potion.effect.poison": "שיקוי השתהות של רעל",
  "item.minecraft.lingering_potion.effect.regeneration": "שיקוי השתהות של התחדשות",
  "item.minecraft.lingering_potion.effect.slow_falling": "שיקוי משתהה של נפילה איטית",
  "item.minecraft.lingering_potion.effect.slowness": "שיקוי השתהות של איטיות",
  "item.minecraft.lingering_potion.effect.strength": "שיקוי השתהות של כוח",
  "item.minecraft.lingering_potion.effect.swiftness": "שיקוי השתהות של זריזות",
  "item.minecraft.lingering_potion.effect.thick": "שיקוי השתהות עבה",
  "item.minecraft.lingering_potion.effect.turtle_master": "שיקוי משתהה של מאסטר הצב",
  "item.minecraft.lingering_potion.effect.water": "בקבוק מים משתהה",
  "item.minecraft.lingering_potion.effect.water_breathing": "שיקוי השתהות של נשימה תת-מימית",
  "item.minecraft.lingering_potion.effect.weakness": "שיקוי השתהות של חולשה",
  "item.minecraft.lingering_potion.effect.weaving": "שיקוי השתהות של טוויה",
  "item.minecraft.lingering_potion.effect.wind_charged": "שיקוי השתהות של טעינת רוח",
  "item.minecraft.llama_spawn_egg": "ביצת זימון למה",
  "item.minecraft.lodestone_compass": "מצפן מגנטיט",
  "item.minecraft.mace": "אלת מחץ",
  "item.minecraft.magenta_bundle": "שק מג'נטה",
  "item.minecraft.magenta_dye": "צבע מג'נטה",
  "item.minecraft.magenta_harness": "רתמה מג'נטה",
  "item.minecraft.magma_cream": "קרם מאגמה",
  "item.minecraft.magma_cube_spawn_egg": "ביצת זימון קוביית מאגמה",
  "item.minecraft.mangrove_boat": "סירת מנגרוב",
  "item.minecraft.mangrove_chest_boat": "סירת מנגרוב עם תיבה",
  "item.minecraft.map": "מפה ריקה",
  "item.minecraft.melon_seeds": "זרעי אבטיח",
  "item.minecraft.melon_slice": "פרוסת אבטיח",
  "item.minecraft.milk_bucket": "דלי חלב",
  "item.minecraft.minecart": "קרונית",
  "item.minecraft.miner_pottery_shard": "שבר חרס כורה",
  "item.minecraft.miner_pottery_sherd": "שבר חרס כורה",
  "item.minecraft.mojang_banner_pattern": "תבנית דגל",
  "item.minecraft.mojang_banner_pattern.desc": "סמל",
  "item.minecraft.mojang_banner_pattern.new": "תבנית דגל של דבר",
  "item.minecraft.mooshroom_spawn_egg": "ביצת זימון מושרום",
  "item.minecraft.mourner_pottery_shard": "שבר חרס אבל",
  "item.minecraft.mourner_pottery_sherd": "שבר חרס אבל",
  "item.minecraft.mule_spawn_egg": "ביצת זימון פרד",
  "item.minecraft.mushroom_stew": "תבשיל פטריות",
  "item.minecraft.music_disc_11": "דיסק מוזיקה",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "דיסק מוזיקה",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "דיסק מוזיקה",
  "item.minecraft.music_disc_5.desc": "סמואל אוברג - 5",
  "item.minecraft.music_disc_blocks": "דיסק מוזיקה",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "דיסק מוזיקה",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "דיסק מוזיקה",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "דיסק מוזיקה",
  "item.minecraft.music_disc_creator.desc": "לנה ריין - Creator",
  "item.minecraft.music_disc_creator_music_box": "דיסק מוזיקה",
  "item.minecraft.music_disc_creator_music_box.desc": "לנה ריין - Creator (Music Box)",
  "item.minecraft.music_disc_far": "דיסק מוזיקה",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "דיסק מוזיקה",
  "item.minecraft.music_disc_lava_chicken.desc": "הייפר פואושנס - Lava Chicken",
  "item.minecraft.music_disc_mall": "דיסק מוזיקה",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "דיסק מוזיקה",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "דיסק מוזיקה",
  "item.minecraft.music_disc_otherside.desc": "לנה ריין - otherside",
  "item.minecraft.music_disc_pigstep": "דיסק מוזיקה",
  "item.minecraft.music_disc_pigstep.desc": "לנה ריין - Pigstep",
  "item.minecraft.music_disc_precipice": "דיסק מוזיקה",
  "item.minecraft.music_disc_precipice.desc": "ארון שרוף - Precipice",
  "item.minecraft.music_disc_relic": "דיסק מוזיקה",
  "item.minecraft.music_disc_relic.desc": "ארון שרוף - Relic",
  "item.minecraft.music_disc_stal": "דיסק מוזיקה",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "דיסק מוזיקה",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "דיסק מוזיקה",
  "item.minecraft.music_disc_tears.desc": "עמוס רודי - Tears",
  "item.minecraft.music_disc_wait": "דיסק מוזיקה",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "דיסק מוזיקה",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "בשר כבש נא",
  "item.minecraft.name_tag": "תג שם",
  "item.minecraft.nautilus_shell": "קונכיית שייטן",
  "item.minecraft.nautilus_spawn_egg": "ביצת זימון שייטן",
  "item.minecraft.nether_brick": "לבנת נד'ר",
  "item.minecraft.nether_star": "כוכב נד'ר",
  "item.minecraft.nether_wart": "שיבולת נד'ר",
  "item.minecraft.netherite_axe": "גרזן נד'רייט",
  "item.minecraft.netherite_boots": "מגפי נד'רייט",
  "item.minecraft.netherite_chestplate": "שריון נד'רייט",
  "item.minecraft.netherite_helmet": "קסדת נד'רייט",
  "item.minecraft.netherite_hoe": "מעדר נד'רייט",
  "item.minecraft.netherite_horse_armor": "שריון סוס מנד'רייט",
  "item.minecraft.netherite_ingot": "מטיל נד'רייט",
  "item.minecraft.netherite_leggings": "מכנסי נד'רייט",
  "item.minecraft.netherite_nautilus_armor": "שריון שייטן מנד'רייט",
  "item.minecraft.netherite_pickaxe": "מכוש נד'רייט",
  "item.minecraft.netherite_scrap": "נד'רייט מנופץ",
  "item.minecraft.netherite_shovel": "את נד'רייט",
  "item.minecraft.netherite_spear": "חנית נד'רייט",
  "item.minecraft.netherite_sword": "חרב נד'רייט",
  "item.minecraft.netherite_upgrade_smithing_template": "שבלונת נפחות",
  "item.minecraft.netherite_upgrade_smithing_template.new": "שדרוג לנד'רייט",
  "item.minecraft.oak_boat": "סירת אלון",
  "item.minecraft.oak_chest_boat": "סירת אלון עם תיבה",
  "item.minecraft.ocelot_spawn_egg": "ביצת זימון אוצלוט",
  "item.minecraft.ominous_bottle": "בקבוק מקולל",
  "item.minecraft.ominous_trial_key": "מפתח אתגרים מקולל",
  "item.minecraft.orange_bundle": "שק כתום",
  "item.minecraft.orange_dye": "צבע כתום",
  "item.minecraft.orange_harness": "רתמה כתומה",
  "item.minecraft.painting": "ציור",
  "item.minecraft.pale_oak_boat": "סירת אלון חיוור",
  "item.minecraft.pale_oak_chest_boat": "סירת אלון חיוור עם תיבה",
  "item.minecraft.panda_spawn_egg": "ביצת זימון פנדה",
  "item.minecraft.paper": "נייר",
  "item.minecraft.parched_spawn_egg": "ביצת זימון מיובש",
  "item.minecraft.parrot_spawn_egg": "ביצת זימון תוכי",
  "item.minecraft.phantom_membrane": "קרום פאנטום",
  "item.minecraft.phantom_spawn_egg": "ביצת זימון פאנטום",
  "item.minecraft.pig_spawn_egg": "ביצת זימון חזיר",
  "item.minecraft.piglin_banner_pattern": "תבנית דגל",
  "item.minecraft.piglin_banner_pattern.desc": "חוטם",
  "item.minecraft.piglin_banner_pattern.new": "תבנית דגל של חוטם",
  "item.minecraft.piglin_brute_spawn_egg": "ביצת זימון פיגלין פראי",
  "item.minecraft.piglin_spawn_egg": "ביצת זימון פיגלין",
  "item.minecraft.pillager_spawn_egg": "ביצת זימון שודד כפרים",
  "item.minecraft.pink_bundle": "שק ורוד",
  "item.minecraft.pink_dye": "צבע ורוד",
  "item.minecraft.pink_harness": "רתמה ורודה",
  "item.minecraft.pitcher_plant": "צמח כדנית",
  "item.minecraft.pitcher_pod": "תרמיל כדנית",
  "item.minecraft.plenty_pottery_shard": "שבר חרס שפע",
  "item.minecraft.plenty_pottery_sherd": "שבר חרס שפע",
  "item.minecraft.poisonous_potato": "תפוח אדמה מורעל",
  "item.minecraft.polar_bear_spawn_egg": "ביצת זימון דוב קוטב",
  "item.minecraft.popped_chorus_fruit": "פרי קורוס מנופץ",
  "item.minecraft.porkchop": "צלע חזיר נא",
  "item.minecraft.potato": "תפוח אדמה",
  "item.minecraft.potion": "שיקוי",
  "item.minecraft.potion.effect.awkward": "שיקוי מביך",
  "item.minecraft.potion.effect.empty": "שיקוי בלתי ניתן להכנה",
  "item.minecraft.potion.effect.fire_resistance": "שיקוי חסינות לאש",
  "item.minecraft.potion.effect.harming": "שיקוי פגיעה",
  "item.minecraft.potion.effect.healing": "שיקוי ריפוי",
  "item.minecraft.potion.effect.infested": "שיקוי שריצה",
  "item.minecraft.potion.effect.invisibility": "שיקוי היעלמות",
  "item.minecraft.potion.effect.leaping": "שיקוי זינוק",
  "item.minecraft.potion.effect.levitation": "שיקו ריחוף",
  "item.minecraft.potion.effect.luck": "שיקוי מזל",
  "item.minecraft.potion.effect.mundane": "שיקוי רגיל",
  "item.minecraft.potion.effect.night_vision": "שיקוי ראיית לילה",
  "item.minecraft.potion.effect.oozing": "שיקוי דליפה",
  "item.minecraft.potion.effect.poison": "שיקוי רעל",
  "item.minecraft.potion.effect.regeneration": "שיקוי התחדשות",
  "item.minecraft.potion.effect.slow_falling": "שיקוי נפילה איטית",
  "item.minecraft.potion.effect.slowness": "שיקוי איטיות",
  "item.minecraft.potion.effect.strength": "שיקוי כוח",
  "item.minecraft.potion.effect.swiftness": "שיקוי זריזות",
  "item.minecraft.potion.effect.thick": "שיקוי עבה",
  "item.minecraft.potion.effect.turtle_master": "שיקוי של מאסטר הצב",
  "item.minecraft.potion.effect.water": "בקבוק מים",
  "item.minecraft.potion.effect.water_breathing": "שיקוי נשימה תת-מימית",
  "item.minecraft.potion.effect.weakness": "שיקוי חולשה",
  "item.minecraft.potion.effect.weaving": "שיקוי טוויה",
  "item.minecraft.potion.effect.wind_charged": "שיקוי טעינת רוח",
  "item.minecraft.pottery_shard_archer": "רסיס חרס קשת",
  "item.minecraft.pottery_shard_arms_up": "שבר חרס ידיים למעלה",
  "item.minecraft.pottery_shard_prize": "שבר חרס פרס",
  "item.minecraft.pottery_shard_skull": "שבר חרס גולגולת",
  "item.minecraft.powder_snow_bucket": "דלי אבקת שלג",
  "item.minecraft.prismarine_crystals": "קריסטלי פריזמרין",
  "item.minecraft.prismarine_shard": "שבר פריזמרין",
  "item.minecraft.prize_pottery_shard": "שבר חרס פרס",
  "item.minecraft.prize_pottery_sherd": "שבר חרס פרס",
  "item.minecraft.pufferfish": "אבו-נפחא",
  "item.minecraft.pufferfish_bucket": "דלי אבו נפחא",
  "item.minecraft.pufferfish_spawn_egg": "ביצת זימון אבו נפחא",
  "item.minecraft.pumpkin_pie": "פאי דלעת",
  "item.minecraft.pumpkin_seeds": "זרעי דלעת",
  "item.minecraft.purple_bundle": "שק סגול",
  "item.minecraft.purple_dye": "צבע סגול",
  "item.minecraft.purple_harness": "רתמה סגולה",
  "item.minecraft.quartz": "קוורץ נד'ר",
  "item.minecraft.rabbit": "ארנב נא",
  "item.minecraft.rabbit_foot": "רגל ארנב",
  "item.minecraft.rabbit_hide": "עור ארנב",
  "item.minecraft.rabbit_spawn_egg": "ביצת זימון ארנב",
  "item.minecraft.rabbit_stew": "תבשיל ארנב",
  "item.minecraft.raiser_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "עיטור שריון מגביה",
  "item.minecraft.ravager_spawn_egg": "ביצת זימון הרסן",
  "item.minecraft.raw_copper": "נחושת גולמית",
  "item.minecraft.raw_gold": "זהב גולמי",
  "item.minecraft.raw_iron": "ברזל גולמי",
  "item.minecraft.recovery_compass": "מצפן אחזור",
  "item.minecraft.red_bundle": "שק אדום",
  "item.minecraft.red_dye": "צבע אדום",
  "item.minecraft.red_harness": "רתמה אדומה",
  "item.minecraft.redstone": "אבק רדסטון",
  "item.minecraft.resin_brick": "לבנת שרף",
  "item.minecraft.resin_clump": "גוש שרף",
  "item.minecraft.rib_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.rib_armor_trim_smithing_template.new": "עיטור שריון צלע",
  "item.minecraft.rotten_flesh": "בשר רקוב",
  "item.minecraft.saddle": "אוכף",
  "item.minecraft.salmon": "סלמון נא",
  "item.minecraft.salmon_bucket": "דלי סלמון",
  "item.minecraft.salmon_spawn_egg": "ביצת זימון סלמון",
  "item.minecraft.scrape_pottery_sherd": "שבר חרס גילוף",
  "item.minecraft.scute": "חתיכת שריון חיה",
  "item.minecraft.sentry_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "עיטור שריון זקיף",
  "item.minecraft.shaper_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "עיטור שריון מעצב",
  "item.minecraft.sheaf_pottery_shard": "שבר חרס אלומה",
  "item.minecraft.sheaf_pottery_sherd": "שבר חרס אלומה",
  "item.minecraft.shears": "מזמרה",
  "item.minecraft.sheep_spawn_egg": "ביצת זימון כבשה",
  "item.minecraft.shelter_pottery_shard": "שבר חרס מחסה",
  "item.minecraft.shelter_pottery_sherd": "שבר חרס מחסה",
  "item.minecraft.shield": "מגן",
  "item.minecraft.shield.black": "מגן שחור",
  "item.minecraft.shield.blue": "מגן כחול",
  "item.minecraft.shield.brown": "מגן חום",
  "item.minecraft.shield.cyan": "מגן ציאן",
  "item.minecraft.shield.gray": "מגן אפור",
  "item.minecraft.shield.green": "מגן ירוק",
  "item.minecraft.shield.light_blue": "מגן תכלת",
  "item.minecraft.shield.light_gray": "מגן אפור בהיר",
  "item.minecraft.shield.lime": "מגן ליים",
  "item.minecraft.shield.magenta": "מגן מג'נטה",
  "item.minecraft.shield.orange": "מגן כתום",
  "item.minecraft.shield.pink": "מגן ורוד",
  "item.minecraft.shield.purple": "מגן סגול",
  "item.minecraft.shield.red": "מגן אדום",
  "item.minecraft.shield.white": "מגן לבן",
  "item.minecraft.shield.yellow": "מגן צהוב",
  "item.minecraft.shulker_shell": "קונכיית שולקר",
  "item.minecraft.shulker_spawn_egg": "ביצת זימון שולקר",
  "item.minecraft.sign": "שלט",
  "item.minecraft.silence_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.silence_armor_trim_smithing_template.new": "עיטור שריון דממה",
  "item.minecraft.silverfish_spawn_egg": "ביצת זימון דג כסף",
  "item.minecraft.skeleton_horse_spawn_egg": "ביצת זימון שלד סוס",
  "item.minecraft.skeleton_spawn_egg": "ביצת זימון שלד",
  "item.minecraft.skull_banner_pattern": "תבנית דגל",
  "item.minecraft.skull_banner_pattern.desc": "מטען גולגולת",
  "item.minecraft.skull_banner_pattern.new": "תבנית דגל של מטען גולגולת",
  "item.minecraft.skull_pottery_shard": "שבר חרס גולגולת",
  "item.minecraft.skull_pottery_sherd": "שבר חרס גולגולת",
  "item.minecraft.slime_ball": "כדור רפש",
  "item.minecraft.slime_spawn_egg": "ביצת זימון רפש",
  "item.minecraft.smithing_template": "שבלונת נפחות",
  "item.minecraft.smithing_template.applies_to": "חל על:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "הוסף מטיל או קריסטל",
  "item.minecraft.smithing_template.armor_trim.applies_to": "שריון",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "הוסף חלק שריון",
  "item.minecraft.smithing_template.armor_trim.ingredients": "מטילים וקריסטלים",
  "item.minecraft.smithing_template.ingredients": "מרכיבים:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "הוסף מטיל נד'רייט",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "ציוד יהלום",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "הוסף שריון, נשק או כלי - מיהלום",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "מטיל נד'רייט",
  "item.minecraft.smithing_template.upgrade": "שדרוג: ",
  "item.minecraft.sniffer_spawn_egg": "ביצת זימון רחרחן",
  "item.minecraft.snort_pottery_shard": "שבר חרס חרחור",
  "item.minecraft.snort_pottery_sherd": "שבר חרס חרחור",
  "item.minecraft.snout_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.snout_armor_trim_smithing_template.new": "עיטור שריון חוטם",
  "item.minecraft.snow_golem_spawn_egg": "ביצת זימון גולם שלג",
  "item.minecraft.snowball": "כדור שלג",
  "item.minecraft.spectral_arrow": "חץ זוהר",
  "item.minecraft.spider_eye": "עין עכביש",
  "item.minecraft.spider_spawn_egg": "ביצת זימון עכביש",
  "item.minecraft.spire_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.spire_armor_trim_smithing_template.new": "עיטור שריון צריח",
  "item.minecraft.splash_potion": "שיקוי התזה",
  "item.minecraft.splash_potion.effect.awkward": "שיקוי התזה מביך",
  "item.minecraft.splash_potion.effect.empty": "שיקוי התזה בלתי ניתן להכנה",
  "item.minecraft.splash_potion.effect.fire_resistance": "שיקוי התזה של חסינות לאש",
  "item.minecraft.splash_potion.effect.harming": "שיקוי התזה של פגיעה",
  "item.minecraft.splash_potion.effect.healing": "שיקוי התזה של ריפוי",
  "item.minecraft.splash_potion.effect.infested": "שיקוי התזה של שריצה",
  "item.minecraft.splash_potion.effect.invisibility": "שיקוי התזה של היעלמות",
  "item.minecraft.splash_potion.effect.leaping": "שיקוי התזה של זינוק",
  "item.minecraft.splash_potion.effect.levitation": "שיקוי התזה של ריחוף",
  "item.minecraft.splash_potion.effect.luck": "שיקוי התזה של מזל",
  "item.minecraft.splash_potion.effect.mundane": "שיקוי התזה רגיל",
  "item.minecraft.splash_potion.effect.night_vision": "שיקוי התזה של ראיית לילה",
  "item.minecraft.splash_potion.effect.oozing": "שיקוי התזה של דליפה",
  "item.minecraft.splash_potion.effect.poison": "שיקוי התזה של רעל",
  "item.minecraft.splash_potion.effect.regeneration": "שיקוי התזה של התחדשות",
  "item.minecraft.splash_potion.effect.slow_falling": "שיקוי התזה של נפילה איטית",
  "item.minecraft.splash_potion.effect.slowness": "שיקוי התזה של איטיות",
  "item.minecraft.splash_potion.effect.strength": "שיקוי התזה של כוח",
  "item.minecraft.splash_potion.effect.swiftness": "שיקוי התזה של זריזות",
  "item.minecraft.splash_potion.effect.thick": "שיקוי התזה עבה",
  "item.minecraft.splash_potion.effect.turtle_master": "שיקוי התזה של מאסטר הצב",
  "item.minecraft.splash_potion.effect.water": "בקבוק מים לזריקה",
  "item.minecraft.splash_potion.effect.water_breathing": "שיקוי התזה של נשימה תת-מימית",
  "item.minecraft.splash_potion.effect.weakness": "שיקוי התזה של חולשה",
  "item.minecraft.splash_potion.effect.weaving": "שיקוי התזה של טוויה",
  "item.minecraft.splash_potion.effect.wind_charged": "שיקוי התזה של טעינת רוח",
  "item.minecraft.spruce_boat": "סירת אשוחית",
  "item.minecraft.spruce_chest_boat": "סירת אשוחית עם תיבה",
  "item.minecraft.spyglass": "טלסקופ",
  "item.minecraft.squid_spawn_egg": "ביצת זימון דיונון",
  "item.minecraft.stick": "מקל",
  "item.minecraft.stone_axe": "גרזן אבן",
  "item.minecraft.stone_hoe": "מעדר אבן",
  "item.minecraft.stone_pickaxe": "מכוש אבן",
  "item.minecraft.stone_shovel": "את אבן",
  "item.minecraft.stone_spear": "חנית אבן",
  "item.minecraft.stone_sword": "חרב אבן",
  "item.minecraft.stray_spawn_egg": "ביצת זימון תועה",
  "item.minecraft.strider_spawn_egg": "ביצת זימון סטריידר",
  "item.minecraft.string": "חוט",
  "item.minecraft.sugar": "סוכר",
  "item.minecraft.suspicious_stew": "תבשיל מסתורי",
  "item.minecraft.sweet_berries": "פירות יער מתוקים",
  "item.minecraft.tadpole_bucket": "דלי ראשן",
  "item.minecraft.tadpole_spawn_egg": "ביצת זימון ראשן",
  "item.minecraft.tide_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.tide_armor_trim_smithing_template.new": "עיטור שריון גאות",
  "item.minecraft.tipped_arrow": "חץ טבול",
  "item.minecraft.tipped_arrow.effect.awkward": "חץ טבול",
  "item.minecraft.tipped_arrow.effect.empty": "חץ טבול לא ניתן להכנה",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "חץ חסינות לאש",
  "item.minecraft.tipped_arrow.effect.harming": "חץ פגיעה",
  "item.minecraft.tipped_arrow.effect.healing": "חץ ריפוי",
  "item.minecraft.tipped_arrow.effect.infested": "חץ שריצה",
  "item.minecraft.tipped_arrow.effect.invisibility": "חץ היעלמות",
  "item.minecraft.tipped_arrow.effect.leaping": "חץ זינוק",
  "item.minecraft.tipped_arrow.effect.levitation": "חץ ריחוף",
  "item.minecraft.tipped_arrow.effect.luck": "חץ מזל",
  "item.minecraft.tipped_arrow.effect.mundane": "חץ טבול",
  "item.minecraft.tipped_arrow.effect.night_vision": "חץ ראיית לילה",
  "item.minecraft.tipped_arrow.effect.oozing": "חץ דליפה",
  "item.minecraft.tipped_arrow.effect.poison": "חץ רעל",
  "item.minecraft.tipped_arrow.effect.regeneration": "חץ התחדשות",
  "item.minecraft.tipped_arrow.effect.slow_falling": "חץ של נפילה איטית",
  "item.minecraft.tipped_arrow.effect.slowness": "חץ איטיות",
  "item.minecraft.tipped_arrow.effect.strength": "חץ כוח",
  "item.minecraft.tipped_arrow.effect.swiftness": "חץ זריזות",
  "item.minecraft.tipped_arrow.effect.thick": "חץ טבול",
  "item.minecraft.tipped_arrow.effect.turtle_master": "חץ של מאסטר הצב",
  "item.minecraft.tipped_arrow.effect.water": "חץ התזה",
  "item.minecraft.tipped_arrow.effect.water_breathing": "חץ נשימה תת-מימית",
  "item.minecraft.tipped_arrow.effect.weakness": "חץ חולשה",
  "item.minecraft.tipped_arrow.effect.weaving": "חץ טוויה",
  "item.minecraft.tipped_arrow.effect.wind_charged": "חץ טעינת רוח",
  "item.minecraft.tnt_minecart": "קרונית עם חומר נפץ",
  "item.minecraft.torchflower_seeds": "זרעי פרח לפיד",
  "item.minecraft.totem_of_undying": "טוטם האלמוות",
  "item.minecraft.trader_llama_spawn_egg": "ביצת זימון למה של סוחר",
  "item.minecraft.trial_key": "מפתח אתגר",
  "item.minecraft.trident": "קלשון",
  "item.minecraft.tropical_fish": "דג טרופי",
  "item.minecraft.tropical_fish_bucket": "דלי דג טרופי",
  "item.minecraft.tropical_fish_spawn_egg": "ביצת זימון דג טרופי",
  "item.minecraft.turtle_helmet": "שריון צב",
  "item.minecraft.turtle_scute": "חתיכת שריון צב",
  "item.minecraft.turtle_spawn_egg": "ביצת זימון צב",
  "item.minecraft.vex_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.vex_armor_trim_smithing_template.new": "עיטור שריון וקס",
  "item.minecraft.vex_spawn_egg": "ביצת זימון ווקס",
  "item.minecraft.villager_spawn_egg": "ביצת זימון כפרי",
  "item.minecraft.vindicator_spawn_egg": "ביצת זימון מרטש",
  "item.minecraft.wandering_trader_spawn_egg": "ביצת זימון סוחר נודד",
  "item.minecraft.ward_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.ward_armor_trim_smithing_template.new": "עיטור שריון וורדן",
  "item.minecraft.warden_spawn_egg": "ביצת זימון וורדן",
  "item.minecraft.warped_fungus_on_a_stick": "פטריה מעוותת על מקל",
  "item.minecraft.water_bucket": "דלי מים",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "עיטור שריון מאתר דרכים",
  "item.minecraft.wheat": "חיטה",
  "item.minecraft.wheat_seeds": "זרעי חיטה",
  "item.minecraft.white_bundle": "שק לבן",
  "item.minecraft.white_dye": "צבע לבן",
  "item.minecraft.white_harness": "רתמה לבנה",
  "item.minecraft.wild_armor_trim_smithing_template": "שבלונת נפחות",
  "item.minecraft.wild_armor_trim_smithing_template.new": "עיטור שריון פרא",
  "item.minecraft.wind_charge": "מטען רוח",
  "item.minecraft.witch_spawn_egg": "ביצת זימון מכשפה",
  "item.minecraft.wither_skeleton_spawn_egg": "ביצת זימון שלד וויד'ר",
  "item.minecraft.wither_spawn_egg": "ביצת זימון וויד'ר",
  "item.minecraft.wolf_armor": "שריון לזאב",
  "item.minecraft.wolf_spawn_egg": "ביצת זימון זאב",
  "item.minecraft.wooden_axe": "גרזן עץ",
  "item.minecraft.wooden_hoe": "מעדר עץ",
  "item.minecraft.wooden_pickaxe": "מכוש עץ",
  "item.minecraft.wooden_shovel": "את עץ",
  "item.minecraft.wooden_spear": "חנית עץ",
  "item.minecraft.wooden_sword": "חרב עץ",
  "item.minecraft.writable_book": "ספר וקולמוס",
  "item.minecraft.written_book": "ספר כתוב",
  "item.minecraft.yellow_bundle": "שק צהוב",
  "item.minecraft.yellow_dye": "צבע צהוב",
  "item.minecraft.yellow_harness": "רתמה צהובה",
  "item.minecraft.zoglin_spawn_egg": "ביצת זימון זוגלין",
  "item.minecraft.zombie_horse_spawn_egg": "ביצת זימון זומבי סוס",
  "item.minecraft.zombie_nautilus_spawn_egg": "ביצת זימון שייטן זומבי",
  "item.minecraft.zombie_spawn_egg": "ביצת זימון זומבי",
  "item.minecraft.zombie_villager_spawn_egg": "ביצת זימון זומבי כפרי",
  "item.minecraft.zombified_piglin_spawn_egg": "ביצת זימון פיגלין זומבי"
}
export const he_il = items; 
